export const fr = {
  nav: {
    overview: "Vue d'ensemble",
    accounts: "Comptes",
    payouts: "Paiements",
    affiliate: "Affiliation",
    support: "Support"
  },
  dashboardheader: {
    serverTime: "Heure du serveur",
    wallet: "Portefeuille",
    settings: "Paramètres",
    logout: "Déconnexion",
    goToProfile: "Aller au profil"
  },
  protectedLayout: {
    connecting: {
      title: "Connexion en cours",
      authenticating: "Authentification...",
      establishing: "Établissement de la connexion..."
    },
    connectionLost: {
      title: "Pas de connexion au serveur",
      description: "La connexion a été interrompue. Nous tentons automatiquement de rétablir la connexion.",
      possibleCauses: "Causes possibles :",
      causes: {
        internet: "Votre connexion Internet a été interrompue",
        maintenance: "Le serveur est actuellement en maintenance",
        firewall: "Votre pare-feu ou proxy bloque la connexion",
        sleep: "Votre appareil est passé en mode veille"
      },
      reconnecting: "Reconnexion...",
      attempt: "Tentative",
      waiting: "En attente de connexion...",
      reloadButton: "Recharger la page manuellement"
    },
    connectionRestored: {
      title: "Connexion rétablie",
      message: "Connecté au serveur"
    }
  },
  accountCards: {
    title: "Comptes de trading",
    addAccount: "Ajouter un compte",
    selectMultiple: "Sélection multiple",
    cancelSelection: "Annuler",
    backToAccounts: "Retour aux comptes",
    balance: "Solde",
    days: "Jours de trading",
    maxLots: "Lots max",
    drawdown: "Drawdown",
    finalPnL: "P&L final",
    current: "Actuel",
    target: "Objectif",
    evaluationFailed: "Évaluation échouée",
    evaluationPassed: "Évaluation réussie",
    evaluationPassedTitle: "Félicitations !",
    congratulationsSuccess: "Vous avez réussi votre évaluation avec succès",
    resetAccount: "Réinitialiser le compte",
    extendAccount: "Prolonger le compte",
    signFundedAgreement: "Activer votre nouveau compte Funded",
    awaitingFundedFee: "En attente des frais Funded",
    payFundedFee: "Payer les frais Funded",
    contractSigned: "Contrat signé - paiement requis",
    livePnL: "P&L en direct",
    today: "aujourd'hui",
    since: "Depuis : ",
    started: "Commencé : ",
    passed: "Réussi : ",
    failed: "Échoué : ",
    expired: "Expiré : ",
    open: "Ouvrir",
    accountExpired: "Compte expiré",
    timeExpired: "Temps expiré",
    accountPeriodEnded: "La période du compte est terminée",
    daysUntilClosure: "Il vous reste seulement {{days}} jours pour prolonger le compte, sinon il sera fermé.",
    deactivationReasons: {
      "Rule Violation": "Violation des règles"
    },
    ruleViolations: {
      "Max Drawdown exceeded": "Drawdown maximum dépassé",
      "Trading outside permitted hours": "Trading en dehors des heures autorisées",
      "Traded more contracts than permitted": "Plus de contrats tradés que permis"
    },
    expiryWarning: "Compte bientôt expiré",
    expiresIn: "Le compte expire dans {{days}} jour(s)",
    noAccountsTitle: "Pas encore de comptes de trading",
    noAccountsDescription: "Commencez en achetant votre premier compte d'évaluation et démarrez votre parcours pour devenir un trader financé",
    fastSetup: "Configuration rapide",
    instantAccess: "Accès instantané",
    noHiddenFees: "Pas de frais cachés",
    status: {
      active: "Actif",
      inProgress: "Évaluation",
      passed: "Réussi",
      failed: "Échoué",
      expired: "Expiré"
    },
    filters: {
      all: "Tous",
      funded: "Funded",
      evaluation: "Évaluation",
      active: "Actifs",
      inactive: "Inactifs",
      resettable: "Réinitialisables",
      expired: "Expirés",
      noResults: "Aucun compte ne correspond à ce filtre",
      showAll: "Afficher tous les comptes"
    }
  },
  accountInformation: {
    title: "Informations du compte",
    accountTimeline: "Chronologie du compte",
    accountSize: "Taille du compte",
    dataFeed: "Flux de données",
    loginCredentials: "Identifiants de connexion",
    username: "Nom d'utilisateur",
    password: "Mot de passe",
    server: "Serveur",
    copy: "Copier",
    important: "Important",
    credentialsNote: "Utilisez ces identifiants pour vous connecter à votre plateforme {dataFeed}. Gardez-les en sécurité et ne les partagez avec personne.",
    startDate: "Date de début",
    expiryDate: "Date d'expiration",
    daysRemaining: "Jours restants",
    days: "jours",
    extend: "Prolonger",
    extendAccount: "Prolonger le compte",
    resetBalance: "Réinitialiser",
    tradingSpecifications: "Spécifications de trading",
    maxPositionSize: "Lots max",
    profitTarget: "Objectif de profit",
    maxDrawdown: "Drawdown max",
    tradingHours: "Heures de trading",
    accountPeriodEnded: "La période du compte est terminée"
  },
  accountSelector: {
    title: "Analyse du compte",
    analytics: "Analyses en direct",
    description: "Suivi des performances en temps réel",
    liveData: "Données en direct",
    account: "Compte",
    status: "Statut"
  },
  performanceMetrics: {
    accountBalance: "Solde du compte",
    netProfit: "Profit net",
    todaysPnL: "P&L du jour",
    winRate: "Taux de réussite",
    tradingDays: "Jours de trading",
    vsYesterday: "vs hier",
    trades: "Trades",
    totalExecuted: "Total exécuté",
    activeDays: "Jours actifs",
    allTime: "Depuis toujours"
  },
  performanceChart: {
    title: "Graphique de performance",
    subtitle: "Solde du compte dans le temps",
    balance: "Solde",
    pnl: "P&L",
    percentage: "Pourcentage",
    currentBalance: "Solde actuel",
    drawdownLimit: "Limite de drawdown",
    profitFactor: "Facteur de profit",
    avgWinLoss: "Gain/Perte moy.",
    target: "Objectif",
    unlimited: "Illimité",
    limit: "Limite",
    start: "Début",
    hoverForDetails: "Survolez les points du graphique pour les détails"
  },
  pnlBreakdown: {
    title: "Répartition P&L",
    subtitle: "Analyse des profits et pertes",
    bySymbol: "Par symbole",
    byTime: "Par période",
    grossProfit: "Profit brut",
    grossLoss: "Perte brute",
    netPnL: "P&L net",
    byTradingSymbol: "Par symbole de trading",
    byTimeOfDay: "Par heure de la journée",
    noData: "Aucune donnée de trading disponible"
  },
  riskAnalysis: {
    title: "Analyse des risques",
    subtitle: "Indicateurs de risque du compte"
  },
  tradeHistory: {
    title: "Historique des trades",
    tradesFound: "trades trouvés",
    export: "Exporter",
    allTrades: "Tous les trades",
    winsOnly: "Gains uniquement",
    lossesOnly: "Pertes uniquement",
    searchPlaceholder: "Rechercher par symbole...",
    symbol: "Symbole",
    type: "Type",
    entry: "Entrée",
    exit: "Sortie",
    qty: "Qté",
    pnl: "P&L",
    duration: "Durée",
    entryDateTime: "Date/Heure d'entrée",
    exitDateTime: "Date/Heure de sortie",
    showing: "Affichage",
    of: "sur",
    trades: "trades",
    previous: "Précédent",
    next: "Suivant",
    winningTrades: "Trades gagnants",
    losingTrades: "Trades perdants",
    totalPnL: "P&L total",
    winRate: "Taux de réussite",
    noTradesFound: "Aucun trade trouvé"
  },
  tradingStatistics: {
    title: "Statistiques de trading",
    subtitle: "Indicateurs de performance détaillés",
    winRate: "Taux de réussite",
    winningTrades: "Trades gagnants",
    losingTrades: "Trades perdants",
    averagePerformance: "Performance moyenne",
    avgWin: "Gain moy.",
    avgLoss: "Perte moy.",
    profitFactor: "Facteur de profit",
    extremes: "Extrêmes",
    largestWin: "Plus grand gain",
    largestLoss: "Plus grande perte",
    bestDay: "Meilleur jour",
    worstDay: "Pire jour",
    streaks: "Séries",
    maxWinningStreak: "Série gagnante max",
    maxLosingStreak: "Série perdante max",
    avgTradeDuration: "Durée moy. des trades",
    trades: "trades"
  },
  affiliate: {
    title: "Programme d'affiliation",
    referralSystem: "Système de parrainage",
    earnCommissions: "Gagnez des commissions en parrainant des traders",
    tier: "Niveau",
    silver: "Argent",
    gold: "Or",
    bonus: "Bonus",
    handleChangedToast: "Votre identifiant d'affilié a été modifié. Vos liens de parrainage ont été mis à jour automatiquement. Veuillez vérifier si des liens marketing précédemment partagés doivent être remplacés.",
    errorTitle: "Impossible de charger les donnees d'affiliation",
    errorSubtitle: "Une erreur est survenue",
    errorDescription: "Nous n'avons pas pu charger vos informations d'affiliation. Cela peut se produire si votre compte d'affiliation n'a pas encore ete configure ou en cas de probleme de connexion temporaire.",
    retry: "Reessayer",
    backToDashboard: "Retour au tableau de bord",
    createAffiliate: "Creer un affilie",
    creating: "Creation en cours...",
    enrollFailed: "Impossible de creer le compte d'affiliation. Veuillez reessayer."
  },
  affiliateOverview: {
    totalEarnings: "Gains totaux",
    activeReferrals: "Références actives",
    conversionRate: "Taux de conversion",
    totalCommissions: "Commissions totales",
    commissionRate: "Taux de commission",
    thisMonth: "ce mois-ci",
    standard: "Standard",
    onAllSales: "sur toutes les ventes",
    vsLastMonth: "vs le mois dernier"
  },
  affiliateTier: {
    tier: "Niveau",
    progressTo: "Progression vers",
    currentAffiliate: "Niveau d'affilié actuel",
    currentBenefits: "Avantages actuels",
    progressToTier: "Progression vers le niveau",
    current: "Actuel",
    allAffiliateTiers: "Tous les niveaux d'affiliation",
    revenue: "revenus",
    nextTierUnlock: "Prochain niveau",
    moreRevenueNeeded: "de revenus supplémentaires nécessaires",
    achieved: "Atteint"
  },
  affiliateStatistics: {
    title: "Statistiques d'affiliation",
    weeklyEarningsOverview: "Vue d'ensemble des gains hebdomadaires",
    day: "Jour",
    week: "Semaine",
    month: "Mois",
    year: "Année",
    currentMonth: "Mois en cours",
    currentQuarter: "Trimestre en cours",
    currentYear: "Année en cours",
    last5Years: "5 dernières années",
    previousMonth: "Mois précédent",
    previousQuarter: "Trimestre précédent",
    previousYear: "Année précédente",
    nextMonth: "Mois suivant",
    nextQuarter: "Trimestre suivant",
    nextYear: "Année suivante",
    monthsAgo: "mois passés",
    monthsAhead: "mois à venir",
    quartersAgo: "trimestres passés",
    quartersAhead: "trimestres à venir",
    yearsAgo: "années passées",
    yearsAhead: "années à venir",
    totalEarningsLabel: "Gains totaux",
    lastWeeks: "12 dernières semaines",
    bestDayLabel: "Meilleur jour",
    bestWeekLabel: "Meilleure semaine",
    bestMonthLabel: "Meilleur mois",
    bestYearLabel: "Meilleure année",
    bestWeek: "Meilleure semaine",
    noData: "Aucune donnée",
    referrals: "parrainages",
    avg: "moy.",
    hoverForDetails: "Survolez les points du graphique pour les détails"
  },
  commissionTracking: {
    title: "Suivi des commissions",
    found: "commissions trouvées",
    all: "Toutes",
    paid: "Payées",
    pending: "En attente",
    posted: "Enregistrées",
    canceled: "Annulées",
    searchPlaceholder: "Rechercher des commissions...",
    commissionId: "ID de commission",
    customer: "Client",
    plan: "Plan",
    commission: "Commission",
    status: "Statut",
    source: "Source",
    purchaseDate: "Date d'achat",
    paidDate: "Date de paiement",
    rate: "taux",
    showing: "Affichage",
    of: "sur",
    commissions: "commissions",
    previous: "Précédent",
    next: "Suivant",
    totalCommission: "Commission totale",
    avgCommission: "Commission moy.",
    onHoldUntil: "En attente jusqu'au",
    postedAt: "Enregistrée le",
    canceledAt: "Annulée le",
    reason: "Raison",
    sourceDetails: "Détails de la source",
    category: "Catégorie",
    code: "Code",
    path: "Chemin",
    noCommissions: "Aucune commission trouvée",
    noCommissionsDescription: "Aucun enregistrement de commission ne correspond à vos filtres"
  },
  earningsOverview: {
    title: "Vue d'ensemble des gains",
    subtitle: "Votre performance d'affiliation",
    month: "Mois",
    quarter: "Trimestre",
    year: "Année",
    totalEarnings: "Gains totaux",
    pending: "Dont en attente",
    performanceMetrics: "Indicateurs de performance",
    conversionRate: "Taux de conversion",
    avgCommission: "Commission moy.",
    transactions: "Transactions",
    totalClicks: "Clics totaux",
    totalConversions: "Conversions totales",
    monthlyProgress: "Progression mensuelle",
    quarterlyProgress: "Progression trimestrielle",
    yearlyProgress: "Progression annuelle",
    allTimeProgress: "Progression globale",
    goalProgress: "Progression de l'objectif",
    goal: "Objectif",
    all: "Tout"
  },
  marketingMaterials: {
    title: "Matériel marketing",
    subtitle: "Ressources professionnelles pour la promotion",
    banners: "Bannières",
    content: "Contenu",
    logos: "Logos",
    availableAssets: "Ressources disponibles",
    quality: "Qualité",
    preview: "Aperçu"
  },
  partnerLandingPage: {
    title: "Page de destination partenaire",
    subtitle: "Votre page de parrainage personnalisée",
    landingPageUrl: "URL de la page de destination",
    copyLink: "Copier le lien",
    partnerName: "Nom du partenaire",
    editText: "Modifier le texte",
    enterPartnerName: "Entrez le nom du partenaire",
    cancel: "Annuler",
    save: "Enregistrer",
    saving: "Enregistrement...",
    landingPageStats: "Statistiques de la page de destination",
    totalVisits: "Visites totales",
    conversions: "Conversions",
    conversionRate: "Taux de conversion",
    revenue: "Revenus",
    commission: "Commission"
  },
  payoutReports: {
    title: "Rapports de paiement",
    subtitle: "Rapports mensuels de commissions & paiements du portefeuille",
    all: "Tous",
    paid: "Payés",
    pending: "En attente",
    completed: "Terminés",
    rejected: "Rejetés",
    canceled: "Annulés",
    totalPaid: "Total payé",
    totalReferrals: "Références totales",
    reports: "Rapports",
    referrals: "parrainages",
    paidToWallet: "Versé au portefeuille",
    paidOn: "Payé le",
    pendingTooltip: "Sera payé à la fin du mois",
    walletPendingTooltip: "La demande de paiement est en cours de traitement",
    walletCompletedTooltip: "Le paiement a été effectué",
    walletRejectedTooltip: "Le paiement a été rejeté",
    walletCanceledTooltip: "Le paiement a été annulé",
    rejectionReason: "Raison",
    walletPayout: "Paiement portefeuille affiliation",
    settlementReport: "Règlement de commissions",
    noReceiptAvailable: "Aucun reçu disponible pour ce paiement",
    showing: "Affichage",
    of: "sur",
    nextPayout: "Prochain paiement",
    exportAllReports: "Exporter tous les rapports",
    noFileAvailable: "Aucun fichier disponible pour ce règlement",
    downloadFailed: "Échec du téléchargement. Veuillez réessayer.",
    noReports: "Aucun rapport de paiement disponible",
    adjustFilters: "Essayez de modifier vos filtres"
  },
  referralLinks: {
    title: "Liens et codes de parrainage",
    subtitle: "Gérez vos liens et codes de parrainage",
    tabLinks: "Liens",
    tabCodes: "Codes",
    createCustomReferralLink: "Créer un lien de parrainage personnalisé",
    createCustomReferralCode: "Créer un code de parrainage personnalisé",
    linkName: "Nom du lien",
    codeName: "Nom du code",
    linkNamePlaceholder: "ex. : Spécial YouTube",
    codeNamePlaceholder: "ex. : YOUTUBE2025",
    description: "Description",
    descriptionPlaceholder: "ex. : Lien spécial pour le contenu YouTube",
    codeDescriptionPlaceholder: "ex. : Code spécial pour les spectateurs YouTube",
    category: "Catégorie",
    categoryPlaceholder: "ex. : YouTube, Instagram, etc.",
    customSlug: "Slug personnalisé (Optionnel)",
    customSlugPlaceholder: "votre-url",
    customCode: "Code personnalisé",
    customCodePlaceholder: "MONCODE2025",
    leaveEmptyNote: "Laissez vide pour générer automatiquement",
    leaveEmptyCodeNote: "Laissez vide pour générer automatiquement le code",
    cancel: "Annuler",
    createLink: "Créer le lien",
    createCode: "Créer le code",
    clicks: "Clics",
    uses: "Utilisations",
    conversions: "Conversions",
    rate: "Taux",
    showing: "Affichage",
    of: "sur",
    links: "liens",
    codes: "codes",
    previous: "Précédent",
    next: "Suivant",
    page: "Page",
    createCustomLink: "Créer un lien personnalisé",
    createCustomCode: "Créer un code personnalisé",
    noLinks: "Aucun lien de parrainage",
    noCodes: "Aucun code de parrainage",
    defaultCodeName: "Standard",
    defaultCodeCategory: "Global",
    defaultCodeDescription: "Code genere par le systeme avec 10% de reduction"
  },
  trafficSources: {
    title: "Sources de trafic",
    subtitle: "D'où vient votre trafic",
    clicks: "clics",
    rate: "taux",
    uses: "utilisations",
    transactions: "transactions",
    noLinksYet: "Aucune source de trafic de liens disponible",
    noCodesYet: "Aucune source de trafic de codes disponible",
    showing: "Affichage",
    of: "sur",
    sources: "sources",
    previous: "Précédent",
    next: "Suivant",
    summary: "Résumé",
    totalClicks: "Clics totaux",
    totalUses: "Utilisations totales",
    conversions: "Conversions",
    totalCommission: "Commission totale",
    avgRate: "Taux moy."
  },
  walletModal: {
    title: "Portefeuille",
    subtitle: "Gérez vos fonds",
    overview: "Vue d'ensemble",
    transactions: "Transactions"
  },
  walletBalance: {
    title: "Solde du portefeuille",
    available: "Fonds disponibles",
    today: "aujourd'hui"
  },
  balanceBreakdown: {
    title: "Répartition du solde",
    affiliateCommissions: "Commissions d'affiliation",
    affiliateDesc: "Gains de parrainages",
    rewards: "Récompenses",
    rewardsDesc: "Gains bonus",
    crediting: "Crédits",
    creditingDesc: "Crédits de compte",
    processing: "Traitement...",
    payout: "Paiement",
    creditsNote: "Les crédits et récompenses sont automatiquement ajoutés à votre solde et peuvent être utilisés pour tous les achats mais ne peuvent pas être retirés."
  },
  transactionHistory: {
    title: "Historique des transactions",
    recentActivity: "Activité récente",
    viewAll: "Voir tout",
    showing: "Affichage",
    of: "sur",
    transactions: "transactions"
  },
  payoutTab: {
    availableForPayout: "Disponible pour paiement",
    affiliateCommissionBalance: "Solde des commissions d'affiliation",
    bankTransfer: "Virement bancaire",
    paypal: "PayPal",
    cryptocurrency: "Cryptomonnaie",
    requestAffiliatePayout: "Demander un paiement d'affiliation",
    withdrawCommissionEarnings: "Retirer vos gains de commissions",
    selectPaymentMethod: "Sélectionner le mode de paiement",
    payoutSummary: "Résumé du paiement",
    requestedAmount: "Montant demandé",
    processingFee: "Frais de traitement",
    netAmount: "Montant net",
    processingRequest: "Traitement de la demande...",
    importantNotes: "Notes importantes",
    note1: "Les paiements d'affiliation sont traités sous 1 à 2 jours ouvrables",
    note2: "Le montant minimum de paiement est de 50 € pour tous les modes de paiement",
    note3: "Les frais de traitement varient selon le mode de paiement",
    payoutRequestSubmitted: "Demande de paiement soumise !",
    payoutRequestSuccess: "Votre demande de paiement de ${amount} a été soumise avec succès.",
    affiliateCommissions: "Commissions d'affiliation",
    readyForWithdrawal: "Prêt pour le retrait",
    bankTransferDesc: "Virement direct sur votre compte bancaire",
    free: "Gratuit",
    paypalDesc: "Paiement rapide via PayPal",
    cryptocurrencyDesc: "Paiement via cryptomonnaie",
    account: "Compte",
    amount: "Montant",
    method: "Méthode",
    destination: "Destination",
    processingTime: "Temps de traitement",
    businessDays: "1-3 jours ouvrables",
    fee: "Frais",
    managePayouts: "Gérer les méthodes"
  },
  payouts: {
    title: "Paiements",
    management: "Gestion des paiements",
    description: "Demandez et suivez vos paiements",
    available: "Disponible"
  },
  payoutStats: {
    availableBalance: "Solde disponible",
    totalPaidOut: "Total payé",
    thisMonth: "Ce mois-ci",
    nextPayout: "Prochain paiement",
    pendingPayouts: "Paiements en attente",
    pending: "En attente",
    today: "Aujourd'hui",
    payouts: "paiements",
    allTime: "Depuis toujours",
    january2025: "Janvier 2025",
    tomorrow: "Demain",
    dailySchedule: "Calendrier quotidien",
    automatic: "Automatique"
  },
  payoutRequest: {
    title: "Demander un paiement",
    subtitle: "Retirer vos profits de trading",
    selectAccount: "Sélectionner un compte",
    availableBalance: "Solde disponible",
    payoutAmount: "Montant du paiement",
    minAmount: "Montant min.",
    amountError: "Le montant doit être entre {min} et {max}",
    insufficientBalance: "Votre solde disponible est inférieur au montant minimum de paiement de {min}",
    selectAccountFirst: "Veuillez d'abord sélectionner un compte",
    paymentMethod: "Mode de paiement",
    selectYour: "Sélectionnez votre",
    bankTransfer: "Virement bancaire",
    paypal: "PayPal",
    crypto: "Cryptomonnaie",
    ach: "Virement ACH",
    bankTransferDesc: "Virement bancaire (1-3 jours ouvrables)",
    paypalDesc: "Virement PayPal (instantané)",
    cryptoDesc: "Virement cryptomonnaie (instantané)",
    achDesc: "Virement bancaire via ACH (1-3 jours ouvrables)",
    fee: "Frais",
    free: "Gratuit",
    payoutSummary: "Résumé du paiement",
    requestedAmount: "Montant demandé",
    processingFee: "Frais de traitement",
    netAmount: "Montant net",
    submitRequest: "Soumettre la demande de paiement",
    processing: "Traitement...",
    importantNotes: "Notes importantes",
    note1: "Les paiements sont traités sous 1 à 3 jours ouvrables",
    note2: "Le montant minimum de paiement est de 50 $",
    note3: "Vous ne pouvez demander des paiements qu'à partir de comptes funded",
    available: "Disponible",
    payoutRequestSubmitted: "Demande de paiement soumise !",
    payoutRequestSuccess: "Votre demande de paiement de ${amount} a été soumise avec succès.",
    account: "Compte",
    amount: "Montant",
    method: "Méthode",
    destination: "Destination",
    processingTime: "Temps de traitement",
    businessDays: "1-3 jours ouvrables",
    noFundedAccountsTitle: "Aucun compte Funded disponible",
    noFundedAccountsDesc: "Vous n'avez actuellement aucun compte funded avec un solde disponible pour paiement.",
    noAffiliateBalanceTitle: "Aucun solde d'affiliation disponible",
    noAffiliateBalanceDesc: "Vous n'avez actuellement aucun solde de commission d'affiliation disponible pour paiement.",
    selectCurrency: "Sélectionner la devise",
    currency: "Devise",
    noMethodsConfigured: "Aucune méthode {method} configurée. Veuillez en ajouter une dans les modes de paiement.",
    kycNotVerifiedTitle: "Vérification KYC requise",
    kycNotVerifiedDesc: "Votre identité n'a pas encore été vérifiée. Veuillez compléter la vérification KYC pour pouvoir demander un paiement.",
    verifyKycNow: "Vérifier maintenant"
  },
  payoutEligibility: {
    title: "Éligibilité au paiement",
    loading: "Vérification de l'éligibilité au paiement...",
    error: "Impossible de vérifier l'éligibilité. Veuillez réessayer plus tard.",
    eligible: "Vous êtes éligible pour un paiement",
    notEligible: "Vous n'êtes pas encore éligible pour un paiement",
    rules: "Règles",
    passed: "réussi",
    checkPassed: "Réussi",
    checkFailed: "Échoué",
    required: "Requis",
    actual: "Actuel",
    maxPayout: "Montant maximum de paiement"
  },
  payoutMethods: {
    title: "Modes de paiement",
    subtitle: "Gérez vos modes de paiement",
    add: "Ajouter une méthode",
    paypal: "PayPal",
    default: "Par défaut",
    setDefault: "Définir par défaut",
    addPaymentMethod: "Ajouter un mode de paiement",
    bankTransfer: "Virement bancaire",
    bankTransferDesc: "Virement bancaire direct",
    paypalDesc: "Paiements PayPal",
    crypto: "Cryptomonnaie",
    cryptoDesc: "Paiements crypto",
    ach: "Virement ACH",
    achDesc: "Virement bancaire direct via ACH",
    accountHolder: "Titulaire du compte",
    iban: "IBAN",
    bicSwift: "BIC/SWIFT",
    bankName: "Nom de la banque",
    routingNumber: "Numéro de routage",
    accountNumber: "Numéro de compte",
    enterRoutingNumber: "Entrez le numéro de routage",
    enterAccountNumber: "Entrez le numéro de compte",
    paypalEmail: "E-mail PayPal",
    walletAddress: "Adresse du portefeuille",
    currencyType: "Type de devise",
    accountCurrency: "Devise du compte",
    paypalCurrency: "Devise PayPal",
    enterAccountHolder: "Entrez le nom du titulaire du compte",
    enterIban: "Entrez l'IBAN",
    enterBicSwift: "Entrez le code BIC/SWIFT",
    enterBankName: "Entrez le nom de la banque",
    enterPaypalEmail: "Entrez l'e-mail PayPal",
    enterWalletAddress: "Entrez l'adresse du portefeuille",
    enterCurrencyType: "Entrez le type de devise",
    cancel: "Annuler",
    saveMethod: "Enregistrer la méthode",
    secureEncrypted: "Sécurisé et chiffré",
    securityNote: "Toutes les informations de paiement sont chiffrées et stockées en toute sécurité. Nous ne stockons jamais de données de paiement sensibles."
  },
  payoutHistory: {
    title: "Historique des paiements",
    payoutsFound: "paiements trouvés",
    export: "Exporter",
    allPayouts: "Tous les paiements",
    completed: "Terminés",
    processing: "En traitement",
    failed: "Échoués",
    searchPlaceholder: "Rechercher des paiements...",
    payoutId: "ID de paiement",
    amount: "Montant",
    method: "Méthode",
    status: "Statut",
    requestDateTime: "Date/Heure de demande",
    completedDateTime: "Date/Heure de complétion",
    account: "Compte",
    reference: "Référence",
    action: "Action",
    fee: "Frais",
    net: "Net",
    pending: "En attente",
    cancelPayout: "Annuler le paiement",
    showing: "Affichage",
    of: "sur",
    payouts: "paiements",
    previous: "Précédent",
    next: "Suivant",
    totalNet: "Net total",
    statusPending: "En attente",
    statusCanceled: "Annulé",
    statusCompleted: "Terminé",
    canceledByUser: "Annulé par l'utilisateur",
    noReasonProvided: "Aucune raison fournie",
    noPayoutsFound: "Aucun paiement trouvé",
    noPayoutsMessage: "Aucun enregistrement de paiement ne correspond à vos filtres",
    loading: "Chargement des paiements...",
    pleaseWait: "Veuillez patienter..."
  },
  support: {
    title: "Centre de support",
    subtitle: "Nous sommes là pour vous aider",
    premiumSupport: "Support Premium",
    helpAndFaq: "Aide et FAQ",
    helpAndSupport: "Aide et support",
    getHelpWhenNeeded: "Obtenez de l'aide quand vous en avez besoin",
    available247: "Disponible 24/7",
    maintenanceTitle: "Espace Support en Construction",
    maintenanceMessage: "Nous activons et finalisons actuellement le nouvel espace support. En attendant, veuillez envoyer toutes vos questions a :",
    maintenanceEmail: "support@nextproptrader.com",
    contactUs: "Contactez-nous",
    emailDescription: "Envoyez-nous un e-mail et notre équipe de support vous répondra dans les plus brefs délais.",
    clickToEmail: "Cliquez pour envoyer un e-mail",
    responseTime: "Délai de réponse typique sous 24 heures"
  },
  supportStats: {
    responseTime: "Temps de réponse",
    resolutionRate: "Taux de résolution",
    activeTickets: "Tickets actifs",
    satisfaction: "Satisfaction",
    average: "Moyenne",
    businessHours: "heures ouvrables",
    firstContact: "Premier contact",
    resolution: "résolution",
    vsYesterday: "vs hier",
    thisMonth: "ce mois-ci"
  },
  supportTickets: {
    title: "Tickets de support",
    subtitle: "Suivez et gérez vos tickets",
    loading: "Chargement des tickets...",
    ticketsFound: "tickets trouvés",
    noTicketsFound: "Aucun ticket trouvé",
    adjustFilters: "Essayez de modifier vos filtres ou votre terme de recherche",
    createdLabel: "Créé :",
    updatedLabel: "Mis à jour :",
    all: "Tous",
    open: "Ouvert",
    closed: "Fermé",
    resolved: "Résolu",
    status_open: "OUVERT",
    status_pending: "EN ATTENTE",
    status_in_progress: "EN COURS",
    status_resolved: "RÉSOLU",
    status_closed: "FERMÉ",
    priority_low: "FAIBLE",
    priority_medium: "MOYEN",
    priority_high: "ÉLEVÉ",
    priority_urgent: "URGENT",
    searchPlaceholder: "Rechercher des tickets...",
    ticketId: "ID du ticket",
    subject: "Sujet",
    status: "Statut",
    priority: "Priorité",
    created: "Créé",
    assignedTo: "Assigné à",
    ticketDetails: "Détails du ticket",
    category: "Catégorie",
    lastUpdate: "Dernière mise à jour",
    conversation: "Conversation",
    messages: "messages",
    typeMessage: "Tapez votre message...",
    sendMessage: "Envoyer le message",
    sending: "Envoi...",
    ticketResolved: "Ce ticket a été résolu",
    noMoreMessages: "Plus aucun message ne peut être envoyé",
    closingTicket: "Fermeture du ticket...",
    closeTicket: "Fermer le ticket",
    showing: "Affichage",
    of: "sur",
    tickets: "tickets",
    previous: "Précédent",
    next: "Suivant",
    noMessages: "Aucun message",
    you: "Vous",
    supportTeam: "Équipe de support",
    attachment: "Pièce jointe",
    attachFile: "Joindre un fichier",
    attachments: "Pièces jointes",
    uploading: "Téléchargement...",
    uploadFailed: "Échec du téléchargement",
    uploadingAttachments: "Téléchargement des pièces jointes...",
    fileTooLarge: "Fichier trop volumineux (max 10 Mo)",
    invalidFileType: "Type de fichier invalide",
    allowedTypes: "Autorisés : jpg, png, gif, pdf, doc, docx, txt, zip, rar",
    downloadAttachment: "Télécharger",
    removeAttachment: "Supprimer"
  },
  knowledgeBase: {
    title: "Base de connaissances",
    subtitle: "Trouvez des réponses rapidement",
    searchPlaceholder: "Rechercher des articles...",
    allArticles: "Tous les articles",
    gettingStarted: "Démarrage",
    platformGuide: "Guide de la plateforme",
    evaluationProcess: "Processus d'évaluation",
    payoutsBilling: "Paiements et facturation",
    troubleshooting: "Dépannage",
    popular: "POPULAIRE",
    readTime: "lecture",
    views: "vues",
    updatedLabel: "Mis à jour :",
    noArticlesFound: "Aucun article trouvé",
    adjustSearch: "Essayez de modifier votre terme de recherche ou votre catégorie",
    articlesFound: "articles trouvés",
    viewAll: "Voir tout"
  },
  liveChat: {
    title: "Support",
    subtitle: "Créer un ticket",
    available247: "Disponible 24/7",
    initialBotMessage: "Bonjour ! Je suis là pour vous aider avec toutes vos questions ou problèmes. Comment puis-je vous assister aujourd'hui ?",
    supportAvailable: "Support disponible",
    averageResponse: "Réponse moyenne : < 2 heures",
    newTicket: "Nouveau ticket",
    quickHelpTopics: "Sujets d'aide rapide",
    accountLoginIssues: "Problèmes de compte et de connexion",
    platformTechnicalSupport: "Support technique de la plateforme",
    payoutQuestions: "Questions sur les paiements",
    evaluationProcessHelp: "Aide sur le processus d'évaluation",
    priority: "priorité",
    responseTimes: "Temps de réponse",
    highPriorityText: "Haute priorité",
    mediumPriorityText: "Priorité moyenne",
    lowPriorityText: "Basse priorité",
    supportTeam: "Équipe de support",
    available: "Disponible",
    ticketSubject: "Sujet du ticket",
    describeIssue: "Décrivez votre problème...",
    ticketCreated: "Ticket créé",
    closeTicket: "Fermer le ticket",
    ticketCreatedSuccess: "Merci d'avoir contacté le support ! Votre ticket a été créé avec l'ID : {{ticketId}}. Notre équipe examinera votre demande et répondra dans quelques heures pendant les heures ouvrables.",
    ticketCreationError: "Désolé, nous avons rencontré une erreur lors de la création de votre ticket. Veuillez réessayer ou contacter le support directement.",
    responses: {
      concern: "Je comprends votre préoccupation. Laissez-moi examiner cela pour vous.",
      escalate: "Merci pour les informations supplémentaires. Je vais transmettre cela à notre équipe technique.",
      question: "C'est une excellente question ! Laissez-moi vous fournir les détails.",
      noted: "J'ai noté cela dans votre ticket. Notre équipe enquêtera davantage.",
      anything: "Y a-t-il autre chose avec laquelle je peux vous aider concernant ce problème ?"
    },
    whatHappensNext: "Que se passe-t-il ensuite ?",
    whatHappensNextDescription: "Notre équipe de support examinera votre ticket et répondra dans le délai prévu en fonction de votre niveau de priorité. Vous recevrez des mises à jour par e-mail.",
    createAnotherTicket: "Créer un autre ticket",
    ticketIdLabel: "ID du ticket",
    statusLabel: "Statut",
    statusOpen: "OUVERT",
    creatingTicket: "Création du ticket...",
    categoryLabel: "Catégorie",
    categories: {
      general: "Général",
      account: "Compte",
      technical: "Technique",
      payout: "Paiement",
      evaluation: "Évaluation"
    }
  },
  faqSection: {
    badge: "Questions frequemment posees",
    title: "Tout ce que vous devez",
    titleHighlight: "savoir",
    subtitle: "Reponses aux questions les plus importantes sur notre programme de prop trading.",
    questions: {
      q1: {
        question: "Comment fonctionne le partage des profits a 100% ?",
        answer: "Vous conservez 100% des profits realises sur votre compte funded. Nous ne prenons aucune commission car notre modele economique fonctionne differemment : lorsque vous tradez de maniere profitable, nous repliquons vos trades en arriere-plan avec des positions plus importantes. Votre succes est notre succes — c'est pourquoi nous investissons dans votre performance a long terme, pas dans la vente d'evaluations."
      },
      q2: {
        question: "Quelles sont les regles de l'evaluation ?",
        answer: "Il y a 4 regles simples : (1) Vous devez trader au moins 5 jours pour reussir l'evaluation — pas de maximum de jours de trading. (2) Ne depassez pas la taille de lot maximale de votre compte. (3) Restez au-dessus du trailing drawdown. (4) Fermez toutes les positions avant 15h15 CST — le trading reprend a 17h00 CST. L'objectif de profit est de 6-8% selon la taille du compte."
      },
      q3: {
        question: "Qu'est-ce que la Lucky Punch Rule et le Scaling Plan ?",
        answer: "En compte funded, il n'y a que 2 regles. La Lucky Punch Rule : aucun trade ne peut representer plus de 30% de votre P&L total, garantissant une performance constante. Le Scaling Plan : vous commencez avec 1 contrat et debloquez 1 contrat supplementaire pour chaque $2 500 de profit. Apres $2 500 de profit, vous pouvez trader 2 contrats, apres $5 000 vous debloquez 3 contrats, et ainsi de suite."
      },
      q4: {
        question: "A quelle vitesse puis-je etre funded et recevoir des paiements ?",
        answer: "Vous pouvez reussir l'evaluation en seulement 5 jours de trading. Une fois reussi, votre compte funded est generalement active dans les 24 heures les jours ouvrables. Les paiements peuvent etre demandes quotidiennement — nous proposons le virement bancaire, PayPal et la cryptomonnaie. Le montant minimum est de $50 et le traitement prend 1 a 3 jours ouvrables."
      },
      q5: {
        question: "Quels flux de donnees et plateformes utilisez-vous ?",
        answer: "Nous utilisons des flux de donnees de Rithmic et DXFeed, fournissant des donnees de marche Level 2 en temps reel avec une execution sub-milliseconde. Toutes les plateformes capables d'etablir une connexion Rithmic ou DXFeed sont prises en charge. Tous les comptes incluent les donnees de marche CME Non-Professional sans cout supplementaire."
      },
      q6: {
        question: "Qu'est-ce que le trailing drawdown et comment fonctionne-t-il ?",
        answer: "Le trailing drawdown est une limite de perte maximale dynamique qui monte lorsque votre compte atteint de nouveaux sommets. Exemple : si votre compte demarre a $50 000 avec un trailing drawdown de $2 500, votre plancher est a $47 500. Si votre solde monte a $52 000, le plancher passe a $49 500. Le drawdown suit toujours votre solde le plus eleve."
      },
      q7: {
        question: "Combien de comptes puis-je trader en meme temps ?",
        answer: "Il n'y a aucune limite. Vous pouvez trader autant de comptes que vous le souhaitez simultanement. Que vous preferiez gerer un seul compte ou plusieurs a la fois, le choix vous appartient entierement."
      },
      q8: {
        question: "Que se passe-t-il si j'echoue ou si je ne reussis pas a temps ?",
        answer: "Pour les comptes d'evaluation, vous pouvez reinitialiser votre compte moyennant des frais et repartir a zero. Vous pouvez aussi prolonger votre compte a tout moment pour obtenir plus de temps. Pour les comptes funded, si vous enfreignez les regles, vous devrez reussir une nouvelle evaluation pour etre a nouveau funded. Les comptes d'evaluation et funded peuvent etre prolonges a tout moment."
      },
      q9: {
        question: "Y a-t-il des frais funded pour les comptes funded ?",
        answer: "Oui, une fois que vous avez un compte funded, il y a des frais funded mensuels de 95 EUR. Ces frais couvrent tous les couts de logiciel et de donnees, y compris les donnees de marche en temps reel et l'infrastructure technique. Le meilleur : les 95 EUR couvrent TOUS vos comptes funded combines — que vous ayez 1 ou 10 comptes, vous ne payez que 95 EUR par mois. Les frais ne sont dus qu'une fois que vous avez reussi l'evaluation."
      }
    },
    titleDashboard: "Questions frequemment posees",
    subtitleDashboard: "Trouvez des reponses aux questions courantes",
    allCategories: "Toutes les categories",
    general: "General",
    trading: "Trading",
    gettingStarted: "Demarrage",
    evaluation: "Evaluation",
    platform: "Plateforme",
    payouts: "Paiements",
    account: "Compte",
    rules: "Regles",
    articlesFound: "articles trouves",
    searchPlaceholder: "Rechercher des articles...",
    howToStartEvaluation: "Comment commencer une evaluation ?",
    howToStartEvaluationAnswer: "Choisissez votre taille de compte ($10K-$250K) sur la page de tarification et finalisez l'achat. Votre compte d'evaluation est configure automatiquement et vous pouvez commencer a trader immediatement. La periode minimale d'evaluation est de 5 jours de trading.",
    whatIsProfitTarget: "Quel est l'objectif de profit ?",
    whatIsProfitTargetAnswer: "L'objectif de profit est de 6-8% de la taille de votre compte selon le tier choisi. Par exemple, sur un compte de $50K avec un objectif de 6%, vous devez atteindre $3 000 de profit. Il n'y a pas de limite de temps — prenez le temps qu'il vous faut.",
    howLongEvaluation: "Y a-t-il une limite de temps pour l'evaluation ?",
    howLongEvaluationAnswer: "Il n'y a pas de limite de temps maximale pour completer votre evaluation. Vous devez trader au minimum 5 jours pour reussir. Vous pouvez prendre autant de jours que necessaire pour atteindre l'objectif de profit en respectant les regles.",
    howToRequestPayout: "Comment demander un paiement ?",
    howToRequestPayoutAnswer: "Allez dans votre Wallet sur le dashboard et selectionnez l'onglet Paiement. Choisissez votre compte funded, entrez le montant (minimum $50) et selectionnez votre methode preferee : virement bancaire, PayPal ou cryptomonnaie. Le traitement prend 1 a 3 jours ouvrables.",
    whatIsTrailingDrawdown: "Qu'est-ce que le trailing drawdown ?",
    whatIsTrailingDrawdownAnswer: "Le trailing drawdown est une limite de perte dynamique qui monte lorsque votre compte atteint de nouveaux sommets de solde. Si votre compte culmine a $52 000 avec un drawdown de $2 500, votre plancher est a $49 500. Il ne redescend jamais. Cela garantit une gestion responsable du risque tout au long de votre trading.",
    canIUseEA: "Puis-je utiliser des Expert Advisors (EAs) ou des strategies automatisees ?",
    canIUseEAAnswer: "Oui, les EAs et strategies automatisees sont autorises sur notre plateforme. Cependant, ils ne doivent pas utiliser de strategies interdites comme l'arbitrage, le hedging entre comptes, le tick scalping ou toute forme d'exploitation de latence. Les strategies algorithmiques standard sont les bienvenues.",
    whatTradingHours: "Quelles sont les heures de trading ?",
    whatTradingHoursAnswer: "Toutes les positions doivent etre fermees avant 15h15 CST au plus tard. Le trading reprend a 17h00 CST. Cela s'applique aux comptes d'evaluation et funded. Garder des positions apres la cloture n'est pas autorise et peut entrainer une violation des regles.",
    howToChangePassword: "Comment changer mon mot de passe ou mes parametres de securite ?",
    howToChangePasswordAnswer: "Naviguez vers votre page Profil, puis ouvrez l'onglet Parametres. Dans la section Securite, vous pouvez changer votre mot de passe et activer l'authentification a deux facteurs pour une protection supplementaire.",
    whatDataFeeds: "Quels flux de donnees et donnees de marche fournissez-vous ?",
    whatDataFeedsAnswer: "Nous utilisons Rithmic et DXFeed comme fournisseurs de donnees. Chaque compte inclut des donnees de marche Level 2 en temps reel et des donnees CME Non-Professional sans cout supplementaire. Cela garantit une tarification precise avec des vitesses d'execution sub-milliseconde.",
    howToExtendAccount: "Puis-je prolonger ou reinitialiser mon compte d'evaluation ?",
    howToExtendAccountAnswer: "Oui. Vous pouvez prolonger votre compte de 30 jours supplementaires ou le reinitialiser pour repartir a zero, le tout directement depuis votre dashboard. Vous pouvez aussi obtenir des reinitialisations et prolongations gratuites grace a notre systeme d'achievements et de niveaux.",
    whatIsLuckyPunch: "Qu'est-ce que la Lucky Punch Rule ?",
    whatIsLuckyPunchAnswer: "La Lucky Punch Rule signifie qu'aucun trade ne peut depasser 30% de votre P&L total sur un compte funded. Par exemple, si votre profit total est de $5 000, aucun trade individuel ne devrait avoir contribue plus de $1 500. Cela garantit une performance constante plutot que de compter sur un seul trade chanceux.",
    whatIsScalingPlan: "Comment fonctionne le Scaling Plan ?",
    whatIsScalingPlanAnswer: "Vous commencez avec 1 contrat sur votre compte funded. Pour chaque $2 500 de profit cumule, vous debloquez 1 contrat supplementaire. Apres $2 500 de profit, vous pouvez trader 2 contrats, apres $5 000 vous debloquez 3 contrats, et ainsi de suite. Cela garantit une augmentation progressive de votre taille de position.",
    whatPayoutMethods: "Quelles methodes de paiement sont disponibles ?",
    whatPayoutMethodsAnswer: "Nous proposons le virement bancaire, PayPal et les paiements en cryptomonnaie. Le montant minimum est de $50. Le traitement prend 1 a 3 jours ouvrables. Vous pouvez demander des paiements quotidiennement depuis votre wallet. Aucun frais cache.",
    whatAccountSizes: "Quelles tailles de compte sont disponibles ?",
    whatAccountSizesAnswer: "Nous proposons des comptes d'evaluation de $10 000 a $250 000 de capital de trading. Chaque tier a son propre objectif de profit, taille de lot maximale et limite de trailing drawdown. Tous les comptes incluent les donnees de marche Level 2, des flux de donnees CME Non-Professional et un support 24/7.",
    howManyAccounts: "Combien de comptes puis-je trader en meme temps ?",
    howManyAccountsAnswer: "Il n'y a aucune limite. Vous pouvez trader autant de comptes que vous le souhaitez simultanement. Que vous preferiez gerer un seul compte ou plusieurs a la fois, le choix vous appartient entierement.",
    whatIfIFail: "Que se passe-t-il si j'echoue ou si je ne reussis pas a temps ?",
    whatIfIFailAnswer: "Pour les comptes d'evaluation, vous pouvez reinitialiser votre compte moyennant des frais et repartir a zero. Vous pouvez aussi prolonger votre compte a tout moment. Pour les comptes funded, si vous enfreignez les regles, vous devrez reussir une nouvelle evaluation. Les comptes d'evaluation et funded peuvent etre prolonges a tout moment.",
    priority: "Priorite",
    highPriorityText: "Haute priorite",
    mediumPriorityText: "Priorite moyenne",
    lowPriorityText: "Basse priorite",
    noResults: "Aucun article trouve",
    tryDifferentSearch: "Essayez un autre terme de recherche ou filtre.",
    contactTitle: "Vous avez encore des questions ?",
    contactDescription: "Notre equipe est la pour vous aider. Contactez-nous et nous vous repondrons des que possible.",
    contactButton: "Nous contacter"
  },
  notifications: {
    title: "Notifications",
    unread: "non lues",
    markAllRead: "Tout marquer comme lu",
    noNotifications: "Aucune notification",
    allCaughtUp: "Vous êtes à jour !",
    lastUpdated: "Dernière mise à jour",
    tradeClosedTitle: "Trade fermé avec succès",
    tradeClosedMessage: "Votre position NQ1! a été fermée pour un profit de +285 $",
    minutesAgo: "Il y a {minutes} minutes",
    payoutProcessedTitle: "Paiement traité",
    payoutProcessedMessage: "Votre paiement de 2 450 $ a été envoyé sur votre compte bancaire",
    hourAgo: "Il y a 1 heure",
    achievementUnlockedTitle: "Réalisation débloquée !",
    achievementUnlockedMessage: "Vous avez obtenu la réalisation « Maître du risque »",
    hoursAgo: "Il y a {hours} heures",
    riskAlertTitle: "Alerte de gestion des risques",
    riskAlertMessage: "Votre compte approche de la limite de drawdown quotidien",
    marketUpdateTitle: "Mise à jour du marché",
    marketUpdateMessage: "Forte volatilité attendue lors de la publication du NFP",
    dayAgo: "Il y a 1 jour",
    accountVerifiedTitle: "Compte vérifié",
    accountVerifiedMessage: "Votre vérification d'identité a été complétée"
  },
  chatModal: {
    lastSeen: "Vu pour la dernière fois",
    typeMessage: "Tapez un message...",
    viewProfile: "Voir le profil",
    blockUser: "Bloquer l'utilisateur",
    reportUser: "Signaler l'utilisateur",
    deleteChat: "Supprimer la conversation"
  },
  chatOverview: {
    title: "Messages",
    unread: "non lus",
    blockUser: "Bloquer l'utilisateur",
    reportUser: "Signaler l'utilisateur",
    delete: "Supprimer",
    noMessages: "Aucun message",
    startConversation: "Commencez une conversation avec d'autres traders",
    viewAllConversations: "Voir toutes les conversations",
    totalConversations: "conversations totales",
    lastUpdated: "Dernière mise à jour"
  },
  fundedAgreement: {
    title: "Accord Funded",
    legalDocument: "Document juridique",
    signToActivate: "Signez pour activer votre compte funded",
    evaluationPassed: "Évaluation réussie",
    account: "Compte",
    finalPnL: "P&L final",
    evaluationResult: "Résultat de l'évaluation",
    passedDate: "Date de réussite",
    completionDate: "Date de complétion",
    fundedCapital: "Capital funded",
    tradingCapital: "Capital de trading",
    agreementTerms: "Conditions de l'accord",
    pleaseReviewCarefully: "Veuillez lire attentivement avant de signer",
    firstName: "Prénom",
    lastName: "Nom",
    address: "Adresse",
    city: "Ville",
    zipCode: "Code postal",
    country: "Pays",
    emailAddress: "Adresse e-mail",
    addressPlaceholder: "Entrez votre adresse",
    cityPlaceholder: "Entrez votre ville",
    zipCodePlaceholder: "Entrez votre code postal",
    countryPlaceholder: "Sélectionnez votre pays",
    digitalSignature: "Signature numérique",
    clear: "Effacer",
    signHereWithMouseOrFinger: "Signez ici avec la souris ou le doigt",
    pleaseSignAboveToExecute: "Veuillez signer ci-dessus pour exécuter l'accord",
    signToActivateAccount: "Signez pour activer votre compte",
    identificationDocument: "Document d'identification",
    uploadNewDocument: "Télécharger un nouveau document",
    useExistingDocument: "Utiliser un document existant",
    documentSecurity: "Sécurité des documents",
    documentSecurityDesc: "Tous les documents sont chiffrés et stockés en toute sécurité conformément aux réglementations de protection des données.",
    printedName: "Nom imprimé",
    printedNameDesc: "Tapez votre nom légal complet en lettres majuscules",
    printedNameNote: "Cela doit correspondre au nom sur votre document d'identification",
    agreementCheckbox: "J'ai lu et j'accepte toutes les conditions générales de cet accord Funded",
    signAgreement: "Signer l'accord",
    signingAgreement: "Signature de l'accord...",
    requirementsChecklist: "Liste de contrôle des exigences",
    personalDataComplete: "Données personnelles complètes",
    agreementAcceptance: "Acceptation de l'accord",
    importantNotice: "Avis important",
    noticeText1: "Ceci est un accord juridiquement contraignant. Veuillez lire attentivement toutes les conditions avant de signer.",
    noticeText2: "En signant cet accord, vous reconnaissez comprendre et accepter toutes les conditions générales.",
    noticeText3: "Une fois signé, cet accord ne peut être modifié sans le consentement mutuel des deux parties.",
    loadingContract: "Chargement du contrat...",
    errorLoadingContract: "Erreur lors du chargement du contrat"
  },
  agreementSuccess: {
    title: "Accord signé avec succès !",
    description: "Votre accord Funded pour le compte #{accountId} a été signé et traité.",
    accountCreationInfo: "Votre compte funded est en cours de préparation et sera disponible dans les 24 heures.",
    fundedFeeTitle: "Frais mensuels Funded",
    fundedFeeSubtitle: "Requis pour l'activation du compte",
    activeSubscription: "Abonnement actif",
    activeSubscriptionDesc: "Votre abonnement aux frais funded est actif jusqu'au :",
    paymentRequired: "Paiement requis",
    paymentRequiredDesc: "Pour activer votre compte funded, veuillez payer les frais mensuels funded de 95 €.",
    payFundedFee: "Payer les frais Funded (95 €)",
    signedBy: "Signé par",
    signedOn: "Signé le",
    account: "Compte",
    status: "Statut",
    active: "Actif",
    waitingForPayment: "En attente de paiement",
    backToDashboard: "Retour au tableau de bord",
    loadingStatus: "Chargement du statut du contrat...",
    accountActivating: "Activation du compte",
    accountActivatingDesc: "Votre compte funded sera activé dans quelques secondes."
  },
  profile: {
    title: "Profil"
  },
  profileTabs: {
    activity: "Activité",
    achievements: "Réalisations",
    connections: "Connexions",
    documents: "Documents",
    settings: "Paramètres"
  },
  profileHeader: {
    publicProfile: "Profil public",
    privateProfile: "Profil privé",
    trades: "Trades",
    tradingDays: "Jours de trading",
    seasons: "Saisons",
    joined: "Membre depuis",
    follow: "Suivre",
    message: "Message",
    messagesDisabled: "Messages désactivés"
  },
  userHeader: {
    eliteTrader: "Trader d'élite",
    higherProfitSplits: "Partages de profits plus élevés",
    prioritySupport: "Support prioritaire",
    exclusiveFeatures: "Fonctionnalités exclusives",
    dayStreak: "Série de jours",
    day: "jour",
    days: "jours",
    tradingConsistency: "Cohérence de trading",
    currentStreak: "Série actuelle",
    bestStreak: "Meilleure série",
    started: "Commencé",
    lastTrade: "Dernier trade",
    recentTradingDays: "Jours de trading récents",
    trades: "trades",
    keepTradingDaily: "Continuez à trader quotidiennement pour maintenir votre série !",
    amazingConsistency: "Cohérence incroyable ! Vous êtes en feu !",
    greatMomentum: "Excellent élan ! Continuez ainsi !",
    buildingHabits: "Vous construisez de bonnes habitudes de trading !",
    keepItUp: "Continuez ! Chaque jour compte !",
    noStreakTitle: "Pas encore de série",
    noStreakMessage: "Commencez à trader pour construire votre série ! Chaque jour de trading compte pour votre cohérence.",
    level: "Niveau",
    progressTo: "Progression vers",
    currentLevel: "Niveau actuel",
    nextLevel: "Avantages du niveau suivant",
    nextRank: "Rang suivant",
    nextRankAt: "au niveau",
    currentRank: "Rang actuel",
    rankBenefits: "Avantages du rang",
    maxRankReached: "Rang maximum atteint !",
    rewardCredits: "Crédits",
    rewardDiscount: "Réduction unique",
    rewardFreeReset: "Réinitialisation gratuite",
    rewardFreeExtension: "Prolongation gratuite",
    rewardTradingFee: "Frais de trading",
    rewardDrawdownReduction: "Réduction du drawdown",
    account: "Compte",
    tier: "Statut",
    accounts: "Comptes",
    funded: "Funded",
    evaluation: "Évaluation",
    inactive: "Inactif"
  },
  achievements: {
    title: "Réalisations",
    subtitle: "Vos jalons de trading",
    completed: "complétées",
    progress: "Progression",
    earned: "Obtenues",
    remaining: "Restantes",
    previous: "Précédent",
    next: "Suivant",
    page: "Page",
    of: "sur",
    viewAll: "Voir toutes les réalisations",
    achievementStatus: "Statut de la réalisation",
    loading: "Chargement des réalisations...",
    locked: "Verrouillée",
    noAchievements: "Pas encore de réalisations",
    noAchievementsDesc: "Commencez à trader pour débloquer votre première réalisation et suivre votre progression !",
    startTrading: "Commencez votre parcours",
    rarity: {
      common: "Commune",
      rare: "Rare",
      epic: "Épique",
      legendary: "Légendaire",
      special: "Spéciale"
    },
    firstProfit: {
      title: "Premier profit",
      description: "Réalisé votre premier trade profitable"
    },
    profitStreak: {
      title: "Série de profits",
      description: "5 jours consécutifs de profits"
    },
    riskMaster: {
      title: "Maître du risque",
      description: "Jamais dépassé 3 % de drawdown quotidien pendant 30 jours"
    },
    speedDemon: {
      title: "Rapide comme l'éclair",
      description: "Évaluation réussie en 5 jours"
    },
    consistencyKing: {
      title: "Roi de la cohérence",
      description: "15 jours de trading actif"
    },
    profitTarget: {
      title: "Objectif de profit",
      description: "Atteint l'objectif de profit de 6 %"
    },
    highRoller: {
      title: "Gros joueur",
      description: "Trader avec un capital de 100 000 $+"
    },
    winStreak: {
      title: "Série gagnante",
      description: "10 trades gagnants d'affilée"
    },
    perfectMonth: {
      title: "Mois parfait",
      description: "Aucun jour de perte en un mois"
    },
    volumeTrader: {
      title: "Trader de volume",
      description: "Exécuter 1000+ trades"
    },
    profitMachine: {
      title: "Machine à profit",
      description: "Gagner 100 000 $+ de profits totaux"
    },
    diamondHands: {
      title: "Mains de diamant",
      description: "Tenir une position gagnante pendant 24+ heures"
    }
  },
  achievementModal: {
    details: "Détails",
    difficulty: "Difficulté",
    status: "Statut",
    earned: "Obtenue",
    statusLocked: "Verrouillée",
    earnedOn: "Obtenue le",
    progress: "Progression",
    reward: "Récompense",
    tips: "Conseils",
    unlocked: "Réalisation débloquée !",
    congratulations: "Félicitations pour avoir débloqué cette réalisation !",
    locked: "Réalisation verrouillée",
    completeRequirements: "Remplissez les conditions pour débloquer cette réalisation.",
    rarity: "Rareté",
    points: "Points",
    completed: "Terminée !",
    target: "Objectif",
    current: "Actuel",
    description: "Description"
  },
  profileAchievements: {
    title: "Réalisations",
    progress: "Progression",
    rarityBreakdown: "Répartition par rareté",
    achievementDistribution: "Distribution des réalisations",
    recentUnlocks: "Récemment débloquées",
    latestAchievements: "Dernières réalisations",
    all: "Toutes",
    earned: "obtenues",
    complete: "complètes",
    rarityDesc: {
      common: "Réalisations de base",
      rare: "Performance habile",
      epic: "Trading exceptionnel",
      legendary: "Maîtrise d'élite",
      special: "Récompenses uniques"
    }
  },
  profileSeasons: {
    tradingSeasons: "Saisons de trading",
    season: "Saison",
    pastSeasons: "Saisons passées",
    finalLevel: "Niveau final",
    level: "Niveau",
    current: "Actuel"
  },
  profileTradingStats: {
    title: "Statistiques de trading",
    totalTrades: "Trades totaux",
    allTimeExecuted: "Total exécuté depuis toujours",
    tradedLots: "Lots tradés",
    totalExecuted: "Total exécuté",
    winRate: "Taux de réussite",
    profitFactor: "Facteur de profit",
    riskAdjusted: "Ajusté au risque",
    averagePerformance: "Performance moyenne",
    avgWin: "Gain moy.",
    avgLoss: "Perte moy.",
    dailyProfit: "P&L moy. quotidien",
    extremes: "Extrêmes",
    bestDay: "Meilleur jour",
    worstDay: "Pire jour",
    tradingDays: "Jours de trading",
    consistency: "Cohérence",
    maxWins: "Gains max",
    maxLosses: "Pertes max",
    largestWin: "Plus grand gain",
    tradingHoursDistribution: "Distribution des heures de trading",
    lots: "lots",
    trades: "trades",
    marketDistribution: "Distribution des marchés",
    totalLots: "Lots totaux",
    ofTotal: "du total",
    noData: "Aucun trade fermé disponible."
  },
  profileConnections: {
    title: "Réseau de trading",
    tradingNetwork: "Réseau de trading",
    connectWithTraders: "Connectez-vous avec des traders",
    total: "Total",
    followers: "Abonnés",
    following: "Abonnements",
    searchConnections: "Rechercher des connexions...",
    searchNewByUsername: "Rechercher par nom d'utilisateur...",
    userFound: "Utilisateur trouvé",
    follow: "Suivre",
    notFound: "Non trouvé",
    tier: "Niveau",
    funded: "Funded",
    evaluation: "Évaluation",
    seasons: "Saisons",
    trades: "Trades",
    lastActive: "Dernière activité",
    unfollow: "Ne plus suivre"
  },
  documents: {
    title: "Documents",
    documentCenter: "Centre de documents",
    invoicesAgreements: "Factures et accords",
    invoiceTabTitle: "Factures",
    agreementsTabTitle: "Accords",
    all: "Tous",
    paid: "Payé",
    active: "Actif",
    pending: "En attente",
    searchInvoices: "Rechercher des factures...",
    searchAgreements: "Rechercher des accords...",
    invoices: "Factures",
    invoicesFound: "factures trouvées",
    fundedAgreements: "Accords Funded",
    agreementsFound: "accords trouvés",
    invoice: "Facture",
    amount: "Montant",
    fundedAgreement: "Accord Funded",
    account: "Compte",
    signed: "Signé",
    evaluationPassed: "Évaluation réussie",
    contractCreated: "Contrat créé",
    pendingSignature: "Signature en attente",
    completed: "Terminé",
    passedAccount: "Compte réussi",
    fundedAccount: "Compte Funded",
    terminated: "Résilié",
    awaitingFee: "En attente de frais",
    payFundedFee: "Payer les frais Funded",
    noInvoicesFound: "Aucune facture trouvée",
    noInvoicesFoundCriteria: "Aucune facture ne correspond à vos critères de recherche actuels.",
    status: {
      paid: "Payé",
      active: "Actif",
      pending: "En attente",
      terminated: "Résilié",
      Terminated: "Résilié",
      failed: "Échoué",
      Completed: "Terminé",
      PendingSignature: "Signature en attente",
      AwaitingFee: "En attente de frais",
      Provisioning: "Provisionnement"
    }
  },
  profileSettings: {
    title: "Paramètres du profil",
    customizationHub: "Centre de personnalisation",
    personalizeExperience: "Personnalisez votre expérience",
    profile: "Profil",
    privacy: "Confidentialité",
    notifications: "Notifications",
    security: "Sécurité",
    manageProfileInfo: "Gérez les informations de votre profil",
    controlWhoCanSee: "Contrôlez qui peut voir vos informations",
    customizeNotifications: "Personnalisez vos notifications",
    secureAccount: "Sécurisez votre compte",
    settingsSaved: "Paramètres enregistrés !",
    savingChanges: "Enregistrement des modifications...",
    saveChanges: "Enregistrer les modifications",
    saveAllChanges: "Enregistrer toutes les modifications",
    settings: "Paramètres"
  },
  profileTab: {
    profilePicture: "Photo de profil",
    uploadNew: "Télécharger une nouvelle",
    remove: "Supprimer",
    uploading: "Téléchargement...",
    uploadSuccess: "Avatar mis à jour avec succès",
    uploadError: "Échec du téléchargement. Veuillez réessayer.",
    fileTooLarge: "Fichier trop volumineux. Max 5 Mo.",
    unsupportedFileType: "Type de fichier non pris en charge. Utilisez JPEG, PNG ou WebP.",
    basicInformation: "Informations de base",
    displayName: "Nom d'affichage",
    enterDisplayName: "Entrez votre nom d'affichage",
    username: "Nom d'utilisateur",
    enterUsername: "Entrez votre nom d'utilisateur",
    emailAddress: "Adresse e-mail",
    enterEmail: "Entrez votre adresse e-mail",
    addressInformation: "Informations d'adresse",
    street: "Rue",
    enterStreet: "Entrez votre adresse",
    street2: "Ligne d'adresse 2",
    enterStreet2: "Appartement, suite, etc. (optionnel)",
    postalCode: "Code postal",
    enterPostalCode: "Entrez votre code postal",
    city: "Ville",
    enterCity: "Entrez votre ville",
    stateProvince: "État / Province",
    enterStateProvince: "Entrez votre état ou province",
    country: "Pays",
    selectCountry: "Sélectionnez votre pays",
    addressSaved: "Adresse mise à jour avec succès",
    addressSaveError: "Échec de la mise à jour de l'adresse. Veuillez réessayer.",
    savingAddress: "Enregistrement..."
  },
  privacyTab: {
    profileVisibility: "Visibilité du profil",
    publicAnyone: "Public — Tout le monde peut voir",
    followersOnly: "Abonnés uniquement — Seuls les abonnés peuvent voir",
    privateOnly: "Privé — Seul vous pouvez voir",
    showAchievements: "Afficher les réalisations",
    showAchievementsDesc: "Afficher vos réalisations sur votre profil public",
    allowMessages: "Autoriser les messages",
    allowMessagesDesc: "Autoriser d'autres traders à vous envoyer des messages"
  },
  notificationsTab: {
    emailNotifications: "Notifications par e-mail",
    emailNotificationsDesc: "Recevez des mises à jour importantes par e-mail",
    notifications: "Notifications",
    pushNotifications: "Notifications push",
    pushNotificationsDesc: "Recevez des notifications en temps réel dans votre navigateur",
    followerNotifications: "Notifications d'abonnés",
    followerNotificationsDesc: "Soyez notifié quand quelqu'un vous suit",
    marketUpdates: "Mises à jour du marché",
    marketUpdatesDesc: "Recevez des nouvelles et mises à jour importantes du marché",
    achievementNotifications: "Notifications de réalisations",
    achievementNotificationsDesc: "Soyez notifié quand vous débloquez de nouvelles réalisations",
    emailFollowerNotifications: "Notifications e-mail d'abonnés",
    emailFollowerNotificationsDesc: "Recevez des e-mails quand quelqu'un vous suit",
    emailMarketUpdates: "Mises à jour du marché par e-mail",
    emailMarketUpdatesDesc: "Recevez des nouvelles et mises à jour du marché par e-mail",
    emailAchievementNotifications: "Notifications de réalisations par e-mail",
    emailAchievementNotificationsDesc: "Recevez des notifications de réalisations par e-mail"
  },
  securityTab: {
    changePassword: "Changer le mot de passe",
    changePasswordDesc: "Mettez à jour régulièrement le mot de passe de votre compte pour le garder sécurisé.",
    currentPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    confirmNewPassword: "Confirmer le nouveau mot de passe",
    atLeast8Characters: "Au moins 12 caractères",
    uppercaseLetter: "Lettre majuscule",
    lowercaseLetter: "Lettre minuscule",
    number: "Chiffre",
    specialCharacter: "Caractere special",
    passwordsDoNotMatch: "Les mots de passe ne correspondent pas.",
    hidePassword: "Masquer le mot de passe",
    showPassword: "Afficher le mot de passe",
    reset: "Réinitialiser",
    savePassword: "Enregistrer le mot de passe",
    saving: "Enregistrement...",
    passwordChanged: "Mot de passe modifié avec succès !",
    passwordChangeFailed: "Échec du changement de mot de passe. Veuillez réessayer.",
    reenterPassword: "Ressaisissez votre nouveau mot de passe"
  },
  twoFactor: {
    title: "Authentification à deux facteurs",
    description: "Ajoutez une couche de sécurité supplémentaire à votre compte.",
    authenticatorApp: "Application d'authentification",
    enabled: "Active",
    disabled: "Inactive",
    enabledDesc: "Votre compte est protégé par l'authentification à deux facteurs.",
    disabledDesc: "Activez la 2FA pour ajouter une couche de sécurité supplémentaire.",
    enable: "Activer",
    disable: "Désactiver",
    enabledSuccess: "L'authentification à deux facteurs a été activée avec succès !",
    disabledSuccess: "L'authentification à deux facteurs a été désactivée.",
    disableFailed: "Échec de la désactivation de l'authentification à deux facteurs. Veuillez réessayer.",
    setupTitle: "Configurer la 2FA",
    setupSubtitle: "Sécurisez votre compte avec une application d'authentification",
    setupFailed: "Échec du démarrage de la configuration 2FA. Veuillez réessayer.",
    verifyFailed: "Échec de la vérification. Veuillez vérifier le code et réessayer.",
    step1Title: "Installer une application d'authentification",
    step1Desc: "Téléchargez et installez une application d'authentification sur votre appareil mobile. Vous l'utiliserez pour générer des codes de vérification.",
    recommendedApps: "Applications recommandées :",
    continue: "Continuer",
    initializing: "Initialisation...",
    step2Title: "Scanner le code QR",
    step2Desc: "Ouvrez votre application d'authentification et scannez ce code QR.",
    manualEntry: "Impossible de scanner ? Entrez cette clé manuellement :",
    step3Title: "Vérifier la configuration",
    step3Desc: "Entrez le code à 6 chiffres de votre application d'authentification pour terminer la configuration.",
    verificationCode: "Code de vérification",
    back: "Retour",
    activate: "Activer la 2FA",
    verifying: "Vérification...",
    switchToEmail: "Revenir à l'e-mail"
  },
  comparisonSection: {
    badge: "Pourquoi Nextproptrader ?",
    title: "Nous sommes",
    titleHighlight: "différents",
    titleEnd: "des autres sociétés de prop trading",
    subtitle: "Découvrez pourquoi des milliers de traders choisissent Nextproptrader plutôt que les sociétés de prop trading traditionnelles.",

    features: {
      profitSplit: "Partage des profits",
      payoutFrequency: "Fréquence de paiement",
      hiddenFees: "Frais cachés",
      platformQuality: "Qualité de la plateforme",
      miniMicroScaling: "Scaling Mini/Micro",
      evaluationTime: "Temps d'évaluation"
    },

    nextprop: {
      profitSplit: "100 %",
      payoutFrequency: "Quotidien",
      hiddenFees: "Transparence",
      platformQuality: "Unique et en direct",
      miniMicroScaling: "Échelle 1:10 équitable",
      evaluationTime: "Seulement 5 jours"
    },

    others: {
      profitSplit: "75-90 %",
      payoutFrequency: "Hebdomadaire/Mensuel",
      hiddenFees: "Frais multiples",
      platformQuality: "Basique/Limité",
      miniMicroScaling: "1:1 défavorable",
      evaluationTime: "10-30+ jours"
    },

    table: {
      features: "Fonctionnalités",
      featuresDesc: "Ce qui compte le plus",
      nextproptrader: "Nextproptrader",
      industryLeader: "LEADER DU SECTEUR",
      otherPropFirms: "Autres sociétés de prop trading",
      industryStandard: "Standard du secteur"
    },

    summary: {
      title: "Le gagnant incontesté",
      description: "Nextproptrader surpasse systématiquement les autres sociétés de prop trading sur tous les critères clés qui comptent pour les traders."
    },

    benefits: {
      profitSplit: {
        title: "100 % de partage des profits",
        description: "Gardez tout ce que vous gagnez. Pas de prélèvements ni de frais cachés."
      },
      dailyPayouts: {
        title: "Paiements quotidiens",
        description: "Accédez à vos profits immédiatement, pas des semaines plus tard."
      },
      transparentRules: {
        title: "Règles transparentes",
        description: "Des règles claires et équitables sans restrictions surprises."
      },
      fastEvaluation: {
        title: "Évaluation rapide",
        description: "Soyez funded en seulement 5 jours de trading."
      }
    },

    cta: {
      title: "Prêt à découvrir la",
      titleHighlight: "différence ?",
      description: "Rejoignez des milliers de traders qui ont choisi une meilleure expérience de prop trading.",
      button: "Commencez votre évaluation"
    }
  },
  transparencySection: {
    badge: "Pure Transparence",
    title: "Seulement 2 Regles Simples.",
    titleHighlight: "Aucun Piege Cache.",
    subtitle: "Alors que d'autres societes de prop trading vous noient sous des reglements complexes pour eviter de vous payer, nous restons radicalement simples. Deux regles de consistance claires en funded — c'est tout.",
    others: {
      title: "Autres Societes de Prop",
      subtitle: "Des regles complexes concues pour vous faire echouer",
      rule1: "Des regles de consistance complexes qui changent sans preavis",
      rule2: "Suppression du compte apres seulement 6 paiements — tout recommencer",
      rule3: "Des restrictions cachees qui n'apparaissent qu'au moment du retrait",
      rule4: "Des systemes de regles elabores concus pour rendre les paiements quasi impossibles",
      rule5: "De nouvelles regles appliquees retroactivement aux comptes existants"
    },
    us: {
      title: "Nextproptrader",
      subtitle: "Seulement 2 regles claires en funded",
      rule1: "Regle Lucky Punch : Aucun trade ne doit depasser 30% du PnL total",
      rule2: "Plan de Scaling : Tous les $2 500, un contrat supplementaire est debloque",
      rule3: "C'est tout. Pas de regles cachees, pas de surprises, pas de petits caracteres",
      conclusion: "Deux regles. Transparence totale. Votre succes est la seule chose qui compte."
    },
    rules: {
      luckyPunch: {
        title: "Regle Lucky Punch",
        description: "Votre plus gros trade ne doit pas depasser 30% de votre profit total. Cela garantit que vous construisez une performance constante — sans compter sur un coup de chance.",
        exampleTitle: "Exemple Pratique",
        example: {
          passLabel: "Conforme",
          passText: "PnL Total : $5 000. Plus gros trade : $1 200 (24%). C'est bien en dessous de la limite de 30% — trading constant, aucun probleme.",
          failLabel: "Non Conforme",
          failText: "PnL Total : $3 000. Plus gros trade : $1 500 (50%). Un seul trade represente plus de 30% — cela indique un coup de chance plutot qu'un trading constant.",
          note: "Cette regle garantit simplement que vos profits proviennent de competences constantes, pas d'un seul trade exceptionnel. Elle protege a la fois vous et la societe."
        }
      },
      scalingPlan: {
        title: "Plan de Scaling",
        description: "Vous commencez avec un nombre de base de contrats. Pour chaque $2 500 de profit, vous debloquez un contrat supplementaire. Cela garantit que vous developpez votre trading en securite avec votre compte en croissance.",
        exampleTitle: "Exemple Pratique",
        example: {
          passLabel: "Exemple de Progression",
          passText: "Vous commencez avec 1 contrat. Apres avoir gagne $2 500, vous pouvez trader 2 contrats. Apres $5 000 de profit total, vous debloquez 3 contrats — et ainsi de suite, etape par etape.",
          failLabel: "Ce Qui Ne Fonctionne Pas",
          failText: "Essayer de trader 5 contrats des le premier jour avec un compte funded neuf. Le plan de scaling garantit que vous augmentez progressivement votre taille a mesure que vos profits prouvent que vous etes pret.",
          note: "Le plan de scaling protege votre compte contre un risque excessif dans les premieres phases. A mesure que vos profits augmentent, votre capacite de trading croit naturellement."
        }
      }
    },
    showExample: "Voir l'exemple",
    hideExample: "Masquer l'exemple",
    bottom: {
      title: "Pas de Petits Caracteres.",
      titleHighlight: "Juste du Trading Equitable.",
      description: "Alors que les concurrents inventent de nouvelles regles pour eviter de vous payer, nous vous donnons exactement deux regles de consistance simples. Tout le reste est entre vos mains. Tradez a votre facon — soyez paye a votre facon."
    }
  },
  platformSection: {
    badge: "NEXTPROPTRADER",
    title: "Pourquoi les prop traders",
    titleHighlight: "nous choisissent",
    subtitle: "Des paiements fiables à un modèle axé sur le trading réel, nous offrons l'infrastructure, le support et la vision dont les traders sérieux ont besoin pour réussir.",

    features: {
      reliablePayouts: {
        title: "Paiements fiables",
        description: "Contrairement à de nombreuses sociétés qui inventent des excuses pour retenir vos profits, nous n'avons jamais manqué un paiement. Point final. Soyez payé de manière fiable par virement bancaire, PayPal ou crypto — sans retards, sans drames."
      },
      technology: {
        title: "Technologie de pointe",
        description: "De la connectivité à notre tableau de bord trader, notre technologie est parmi les plus avancées du secteur. Nous innovons constamment pour garder une longueur d'avance — vous offrant la vitesse, la stabilité et les outils dont vous avez besoin pour performer."
      },
      partnerships: {
        title: "Partenariats à long terme",
        description: "Nous ne cherchons pas des évaluations ponctuelles — nous sommes là pour construire des relations à long terme. Grâce à notre programme, les traders à succès accèdent à des opportunités exclusives et à un scaling de capital plus important au fil du temps."
      },
      builtToTrade: {
        title: "Conçu pour le trading — pas seulement pour vendre",
        description: "Contrairement aux sociétés de prop trading à rabais qui survivent uniquement grâce aux frais d'évaluation, nous opérons une véritable infrastructure qui prospère sur la performance de trading réelle. Notre modèle commercial est aligné avec votre succès — car nous grandissons quand vous grandissez."
      }
    },

    profitSplit: {
      title: "Partage des profits",
      subtitle: "Leader du secteur",
      badge: "LEADER DU SECTEUR",
      keepEverything: "Vous gardez tout ce que vous gagnez"
    },

    explanation: {
      title: "Pourquoi 100 % de partage des profits ?",
      believeInSuccess: "Nous croyons en votre succès.",
      paragraph1: "Contrairement aux sociétés de prop trading traditionnelles qui prennent 10 à 20 % de vos profits, nous vous laissons garder 100 % de ce que vous gagnez car vos compétences de trading méritent une récompense complète.",
      paragraph2: "Nous ne prenons pas de commission — car nous évoluons avec vous. Lorsque vous êtes funded et que vous performez bien, nous répliquons vos trades en arrière-plan avec des positions plus importantes. Vous gardez 100 % de vos profits — nous gagnons en scalant votre avantage. Un modèle gagnant-gagnant basé sur la confiance et la performance."
    },

    benefits: {
      hiddenFees: {
        value: "0 $",
        label: "Frais cachés"
      },
      earningPotential: {
        value: "∞",
        label: "Potentiel de gains"
      }
    }
  },
  tradingActivity: {
    title: "Activité de trading",
    subtitle: "Performance en direct",
    description: "Performance de trading et analyses en temps réel"
  },
  recentTrades: {
    title: "Trades du jour",
    subtitle: "Dernière activité de trading",
    quantity: "Lots",
    entry: "Entrée",
    current: "Actuel",
    exit: "Sortie",
    pnl: "P&L",
    duration: "Durée",
    running: "En cours",
    open: "Ouvert",
    closed: "Fermé",
    winners: "Gagnants",
    losers: "Perdants",
    tradedLots: "Lots tradés",
    avgNetPnL: "P&L net moy.",
    noTrades: "Pas de trades aujourd'hui",
    noTradesDesc: "Aucun trade n'a été exécuté aujourd'hui"
  },
  pnlCalendar: {
    title: "Calendrier P&L",
    subtitle: "Vue d'ensemble de la performance quotidienne",
    allAccounts: "Tous les comptes",
    totalPnl: "P&L total",
    totalTrades: "Trades",
    winDays: "Jours gagnants",
    lossDays: "Jours perdants",
    days: {
      sun: "Dim",
      mon: "Lun",
      tue: "Mar",
      wed: "Mer",
      thu: "Jeu",
      fri: "Ven",
      sat: "Sam"
    }
  },
  panelSwitcher: {
    performance: "Performance",
    trades: "Trades"
  },
  dailyPerformanceChart: {
    title: "Graphique de performance",
    subtitle: "14 derniers jours de trading",
    today: "aujourd'hui",
    dailyPnL: "P&L quotidien",
    tradePnL: "P&L par trade",
    bestDay: "Meilleur jour",
    bestTrade: "Meilleur trade",
    avgDaily: "Moy. quotidienne",
    avgPnLToday: "P&L moy. aujourd'hui",
    last14Days: "14 derniers jours",
    worstDay: "Pire jour",
    worstTrade: "Pire trade",
    trades: "trades",
    tradingDays: "Jours de trading",
    perDay: "par jour"
  },
  accountPerformance: {
    title: "Performance du compte",
    subtitle: "Tous les comptes de trading",
    leading: "En tête",
    since: "Depuis",
    noData: "Aucune donnée disponible",
    account: "Compte",
    startBalance: "Solde initial",
    balance: "Solde",
    netPnL: "P&L net",
    performance: "Performance",
    todaysPnL: "P&L du jour"
  },
  todaysSession: {
    title: "Session du jour",
    livePerformance: "Performance en direct",
    active: "Actif",
    totalTrades: "Trades totaux",
    sessionPnL: "P&L de la session",
    winRate: "Taux de réussite",
    winningTrades: "Trades gagnants",
    losingTrades: "Trades perdants",
    avgWin: "Gain moy.",
    avgLoss: "Perte moy.",
    largestWin: "Plus grand gain",
    largestLoss: "Plus grande perte",
    avgTradeDuration: "Durée moy. des trades",
    sessionSummary: "Résumé de la session"
  },
  controlPanel: {
    title: "Panneau de contrôle",
    subtitle: "Gestion des trades",
    live: "En direct",
    openPositions: "Positions ouvertes",
    active: "actif",
    noOpenPositions: "Aucune position ouverte",
    quickActions: "Actions rapides",
    closeAllPositions: "Fermer toutes les positions",
    closingPositions: "Fermeture des positions...",
    close: "Fermer",
    closing: "Fermeture...",
    confirmCloseAll: "Fermer toutes les positions ?",
    confirmMessage: "Êtes-vous sûr de vouloir fermer toutes les {count} positions ouvertes ?",
    cancel: "Annuler",
    closeAll: "Tout fermer"
  },
  addAccountModal: {
    title: "Ajouter un nouveau compte",
    subtitle: "Choisissez votre compte d'évaluation",
    mostPopular: "LE PLUS POPULAIRE",
    tradingCapital: "Capital de trading",
    only: "Seulement",
    per30Days: "/30 jours",
    getAccess: "Accédez à",
    capital: "de capital",
    startEvaluation: "COMMENCER L'ÉVALUATION",
    allPlansInclude: "Tous les plans incluent",
    fullPlatformAccess: "Accès complet à la plateforme",
    completeAccess: "Accès complet à tous les outils de trading",
    level2MarketData: "Données de marché de niveau 2",
    chooseDataFeed: "Choisissez votre flux de données préféré",
    premiumSupport: "Support premium",
    professionalSupport: "Support de trading professionnel 24/7"
  },
  footer: {
    traderFunding: "Financement de traders",
    description: "Nous aidons les traders à monétiser leurs performances simulées grâce à des programmes de financement, des outils de niveau professionnel et des environnements de trading réels — sans risquer leur capital personnel.",
    newsletter: {
      title: "Offres exclusives et réductions limitées",
      description: "Soyez le premier informé des offres à durée limitée et des réductions exclusives pour traders.",
      placeholder: "Entrez votre adresse e-mail",
      subscribe: "S'abonner gratuitement",
      privacy: "Pas de spam. Désabonnement à tout moment. Vos données sont protégées.",
      subscribing: "Abonnement...",
      successMessage: "Veuillez vérifier votre e-mail et confirmer votre abonnement.",
      errorMessage: "Une erreur s'est produite. Veuillez réessayer.",
      invalidEmail: "Veuillez entrer une adresse e-mail valide.",
      confirm: {
        title: "Confirmer votre abonnement",
        subtitle: "Confirmation de la newsletter",
        confirming: "Confirmation de votre abonnement...",
        success: "Votre abonnement a été confirmé avec succès !",
        successDetail: "Vous recevrez désormais nos dernières offres et réductions exclusives directement dans votre boîte de réception.",
        error: "La confirmation a échoué. Le lien est peut-être invalide ou expiré.",
        backToHome: "Retour à la page d'accueil"
      },
      unsubscribe: {
        title: "Se désabonner de la newsletter",
        subtitle: "Préférences de newsletter",
        description: "Êtes-vous sûr de vouloir vous désabonner de notre newsletter ? Vous ne recevrez plus d'offres exclusives et de réductions.",
        button: "Se désabonner",
        unsubscribing: "Désabonnement...",
        success: "Vous avez été désabonné avec succès.",
        successDetail: "Vous ne recevrez plus d'e-mails de newsletter de notre part.",
        error: "Le désabonnement a échoué. Le lien est peut-être invalide ou expiré.",
        backToHome: "Retour à la page d'accueil"
      }
    },
    ourProgram: {
      title: "Notre programme",
      fundingProcess: "Le processus de financement",
      softwareSolution: "Notre solution logicielle",
      profitSplit: "100 % de partage des profits",
      pricing: "Nos tarifs"
    },
    association: {
      title: "Association",
      partnership: "Partenariat",
      whiteLabel: "Marque blanche",
      affiliateProgram: "Programme d'affiliation"
    },
    support: {
      title: "Support",
      faq: "FAQ",
      contact: "Contact"
    },
    copyright: "© {year} Nextproptrader LLC. Tous droits réservés.",
    privacyPolicy: "Politique de confidentialité",
    termsOfService: "Conditions d'utilisation",
    disclaimers: {
      generalDisclosure: {
        title: "Divulgation générale",
        content: "Les matériaux et contenus fournis par Nextproptrader LLC, que ce soit sur notre site web, par des documents distribués ou d'autres communications, sont destinés uniquement à des fins d'information générale. Ce contenu ne constitue pas un conseil en investissement, une offre d'achat ou de vente de titres, ni une approbation d'instruments financiers, de sociétés ou de fonds. Les utilisateurs ne doivent pas interpréter ces informations comme des conseils financiers personnalisés. Les informations fournies ne visent aucune juridiction spécifique et ne doivent pas être utilisées de manière contraire aux lois ou réglementations locales. Nextproptrader LLC, une entité enregistrée au Business Center 1, M Floor, Meydan Grand Stand, Dubai, UAE, respecte toutes les lois locales, étatiques et fédérales applicables. © {year}. Tous droits réservés."
      },
      riskDisclosure: {
        title: "Divulgation des risques",
        content: "Le trading de futures, forex et autres produits à effet de levier comporte un risque substantiel de perte et ne convient pas à tous les investisseurs. Les performances passées ne sont pas nécessairement indicatives des résultats futurs. Vous devez examiner attentivement si le trading vous convient compte tenu de votre situation, de vos connaissances et de vos ressources financières. Vous pouvez perdre la totalité ou plus que votre investissement initial. Les opinions, données de marché et recommandations sont susceptibles de changer à tout moment. Nextproptrader n'est pas un conseiller en investissement enregistré et ne fournit pas de conseils en investissement. Toutes les décisions de trading sont prises par le trader individuel."
      },
      hypotheticalPerformance: {
        title: "Divulgation des performances hypothétiques",
        content: "Les résultats de performances hypothétiques comportent de nombreuses limitations inhérentes. Aucune déclaration n'est faite qu'un compte quelconque réalisera ou est susceptible de réaliser des profits ou des pertes similaires à ceux présentés. En fait, il existe fréquemment de fortes différences entre les résultats de performances hypothétiques et les résultats réels obtenus ultérieurement par un programme de trading particulier. L'une des limitations des résultats de performances hypothétiques est qu'ils sont généralement préparés avec le bénéfice du recul. De plus, le trading hypothétique n'implique pas de risque financier, et aucun enregistrement de trading hypothétique ne peut complètement tenir compte de l'impact du risque financier dans le trading réel. La capacité à supporter des pertes ou à adhérer à un programme de trading particulier malgré les pertes de trading sont des points matériels qui peuvent également affecter négativement les résultats de trading réels."
      },
      finalNotice: "Ce site web et son contenu sont à titre informatif uniquement. Le trading comporte des risques et peut ne pas convenir à tous les investisseurs. Veuillez lire toutes les divulgations de risques avant de trader. Nextproptrader LLC n'est pas responsable des pertes de trading subies par les utilisateurs de cette plateforme."
    },
    systemStatus: {
      title: "État du système",
      subtitle: "Surveillance de la plateforme en temps réel",
      allSystemsOperational: "Tous les systèmes opérationnels",
      platformRunning: "La plateforme fonctionne correctement",
      overallUptime: "Disponibilité globale",
      coreSystems: "Systèmes principaux",
      marketDataFeeds: "Flux de données de marché",
      operational: "Opérationnel",
      maintenance: "Maintenance",
      uptime: "Disponibilité",
      responseTime: "Temps de réponse",
      latency: "Latence",
      statusUpdates: "Mises à jour du statut",
      lastUpdated: "Dernière mise à jour",
      refreshes: "Actualisation toutes les 30 secondes",
      liveMonitoring: "Surveillance en direct",
      systems: {
        tradingPlatform: {
          name: "Plateforme de trading",
          description: "Infrastructure de trading principale"
        },
        userDashboard: {
          name: "Tableau de bord utilisateur",
          description: "Système de gestion des comptes"
        },
        paymentSystem: {
          name: "Système de paiement",
          description: "Traitement des paiements"
        },
        apiServices: {
          name: "Services API",
          description: "Intégrations tierces"
        }
      },
      dataFeeds: {
        rithmic: "Données de marché futures",
        dxfeed: "Données de marché multi-actifs"
      }
    }
  },
  hero: {
    badge: "Nextproptrader 2.0 – Le prop trading, redéfini.",
    headline1: "Vos trades.",
    headline2: "Notre capital.",
    headline3: "De vrais profits.",
    description: "Avec nous, vous pouvez monétiser votre trading simulé — sans aucun risque. Tradez dans un environnement sûr et recevez",
    profitSplit: "100 % de vos profits",
    descriptionEnd: ". Pas de stress — juste vos compétences transformées en vrais profits.",
    getFundedButton: "Soyez funded maintenant",
    learnMoreButton: "En savoir plus",
    stats: {
      capitalAllocated: "En capitalisations",
      capitalSubtitle: "Capital funded",
      fundedAccounts: "Comptes funded",
      accountsSubtitle: "Approuvé par des milliers",
      tradesExecuted: "Trades exécutés",
      tradesSubtitle: "Des millions d'idées. Une seule plateforme."
    },
    dashboard: {
      title: "Tableau de bord",
      subtitle: "Environnement de trading en direct",
      fundedBadge: "Funded",
      accountBalance: "Solde du compte",
      todayPerformance: "aujourd'hui",
      possiblePayout: "Paiement possible",
      payoutButton: "Paiement",
      profitSplit: "100 %",
      profitSplitLabel: "Partage des profits",
      instrument: "NQ1! Futures",
      liveData: "Données en direct",
      todayProfit: "aujourd'hui"
    }
  },
  header: {
    process: "Processus",
    pricing: "Tarifs",
    payouts: "Paiements",
    contact: "Contact",
    login: "Connexion",
    register: "S'inscrire",
    getStarted: "S'inscrire",
    backToMainSite: "Retour au site principal"
  },
  logoutModal: {
    title: "Déconnexion",
    subtitle: "Veuillez patienter pendant que nous vous déconnectons en toute sécurité",
    loggingOut: "Déconnexion...",
    securityMessage: "Nous effaçons votre session en toute sécurité et protégeons les données de votre compte."
  },
  loginModal: {
    welcomeBack: "Bon retour",
    signInToAccount: "Connectez-vous à votre compte",
    resetPassword: "Connexion",
    enterEmailToReset: "Réinitialiser le mot de passe",
    resetInstructions: "Entrez votre adresse e-mail pour réinitialiser votre mot de passe",
    resetLinkSent: "Veuillez vérifier vos e-mails",
    sendingResetLink: "Le lien sera envoyé...",
    emailAddress: "Adresse e-mail",
    enterYourEmail: "Entrez votre e-mail",
    emailOrUsername: "E-mail ou nom d'utilisateur",
    enterEmailOrUsername: "Entrez votre e-mail ou nom d'utilisateur",
    password: "Mot de passe",
    enterYourPassword: "Entrez votre mot de passe",
    rememberMe: "Se souvenir de moi",
    forgotPassword: "Mot de passe oublié ?",
    signIn: "Se connecter",
    enterEmailAddress: "Entrez votre adresse e-mail",
    resetLinkInfo: "Nous vous enverrons un lien sécurisé pour réinitialiser votre mot de passe. Veuillez vérifier votre boîte de réception et votre dossier spam.",
    sendResetLink: "Envoyer le lien de réinitialisation",
    resendInSeconds: "Renvoi possible dans {s}s",
    backToLogin: "← Retour à la connexion",
    or: "ou",
    dontHaveAccount: "Vous n'avez pas de compte ?",
    createOneNow: "Créez-en un maintenant",
    signingIn: "Connexion...",
    enterSecurityCode: "Code de sécurité",
    enterCodeFromApp: "Authentification OTP",
    enterCodeFromEmail: "Entrez le code envoyé à votre e-mail",
    securityCode: "Entrez le code :",
    verifyAndSignIn: "Se connecter",
    verifying: "Vérification",
    resetError: "Une erreur s'est produite. Veuillez réessayer.",
    setNewPassword: "Nouveau mot de passe",
    enterNewPasswordSubtitle: "Définissez votre nouveau mot de passe",
    newPasswordInstructions: "Veuillez entrer votre nouveau mot de passe. Il doit contenir au moins 8 caractères.",
    newPassword: "Nouveau mot de passe",
    enterNewPassword: "Entrez votre nouveau mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    repeatNewPassword: "Répétez votre nouveau mot de passe",
    passwordsMismatch: "Les mots de passe ne correspondent pas.",
    passwordTooShort: "Le mot de passe doit contenir au moins 12 caracteres, un chiffre et un caractere special.",
    resettingPassword: "Enregistrement...",
    saveNewPassword: "Enregistrer le nouveau mot de passe",
    passwordResetSuccess: "Mot de passe modifié",
    passwordResetSuccessMessage: "Votre mot de passe a été réinitialisé avec succès. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
    backToLoginButton: "Retour à la connexion",
    loginFailed: "Connexion echouee. Veuillez verifier votre e-mail/nom d'utilisateur et mot de passe.",
    accountBlocked: "Votre compte est bloque. Veuillez contacter le support a support@nextproptrader.com"
  },
  evaluationProcess: {
    badge: "Votre chemin vers le financement",
    title: "Un processus",
    titleHighlight: "en 4 étapes",
    titleEnd: "d'évaluation simple",
    subtitle: "Notre processus d'évaluation simplifié est conçu pour identifier les traders talentueux et les financer rapidement.",

    steps: {
      step1: {
        title: "Commencez votre évaluation",
        subtitle: "Commencez à trader",
        description: "Choisissez la taille de votre compte et commencez à trader avec notre capital simulé. Aucun risque pour votre propre argent.",
        duration: "Jour 1",
        requirement: "Configuration du compte"
      },
      step2: {
        title: "Atteignez l'objectif de profit",
        subtitle: "Prouvez vos compétences",
        description: "Atteignez votre objectif de profit tout en suivant nos règles de gestion des risques. Montrez une performance de trading cohérente.",
        duration: "5-30 jours",
        requirement: "Objectif de profit 6-8 %"
      },
      step3: {
        title: "Gestion des risques",
        subtitle: "Restez dans les limites",
        description: "Maintenez une bonne gestion des risques tout au long de l'évaluation. Ne dépassez jamais les limites de drawdown maximum.",
        duration: "En continu",
        requirement: "Drawdown max"
      },
      step4: {
        title: "Soyez funded",
        subtitle: "Recevez du vrai capital",
        description: "Félicitations ! Vous avez réussi l'évaluation et recevez maintenant l'accès à votre compte funded.",
        duration: "En quelques minutes",
        requirement: "Activation du compte"
      }
    },

    stepContent: {
      step1: {
        chooseCapital: "Choisir le capital",
        availableRange: "10K $ - 250K $ disponibles",
        startTrading: "Commencer à trader",
        beginImmediately: "Commencez immédiatement"
      },
      step2: {
        profitTargetProgress: "Progression de l'objectif de profit",
        ofAmount: "de 50K $ = 3 000 $"
      },
      step3: {
        riskManagement: "Gestion des risques",
        withinLimits: "✓ Dans les limites",
        maxDrawdown: "Drawdown max",
        dependsOnAccount: "dépend de la taille du compte"
      },
      step4: {
        congratulations: "Félicitations !",
        accountPreparing: "Votre compte funded est en cours de préparation"
      }
    },

    rules: {
      title: "Règles",
      titleHighlight: "d'évaluation",
      subtitle: "Des règles simples et transparentes pour réussir votre évaluation",

      rule1: {
        title: "Financement en 5 jours",
        description: "Soyez funded après 5 jours de trading et il n'y a pas de maximum non plus. Vous pouvez prendre autant de temps que nécessaire."
      },
      rule2: {
        title: "Taille de lot max",
        description: "Ne dépassez pas le nombre maximum de lots autorisés. Chaque compte a une limite différente."
      },
      rule3: {
        title: "Limite de perte max",
        description: "Limitez votre risque et tradez efficacement. Vous ne devez pas descendre en dessous du drawdown suiveur."
      },
      rule4: {
        title: "Heures de trading",
        description: "Vous devez fermer toutes les positions au plus tard à 15h15 CST. Le trading reprend à 17h00 CST."
      }
    }
  },
  solutions: {
    badge: "Donner aux traders les moyens d'agir avec précision",
    title: "Conçu pour le",
    titleHighlight: "prop trading",
    titleEnd: "professionnel",
    subtitle: "Notre plateforme professionnelle fournit les outils et l'infrastructure dont les prop traders ont besoin pour réussir sur les marchés futures d'aujourd'hui.",
    poweredBy: "Propulsé par :",

    premiumDataFeeds: {
      title: "Flux de données premium",
      description: "Données de marché CME professionnelles de fournisseurs de premier plan avec exécution en temps réel.",
      dataPartners: "Nos partenaires de données :",
      subtitle: "Données de niveau 2 en temps réel",
      badge: "Données de marché CME"
    },

    dailyPayouts: {
      title: "Paiements quotidiens",
      description: "Options de paiement rapides et flexibles avec des retraits quotidiens via plusieurs méthodes de paiement.",
      badge: "Rapide et flexible",
      features: {
        dailyWithdrawals: "Retraits quotidiens",
        bankTransfer: "Virement bancaire",
        paypalCrypto: "PayPal et crypto"
      }
    },

    payoutMethods: {
      bank: "Virement",
      transfer: "bancaire",
      paypal: "PayPal",
      payments: "Paiements",
      crypto: "Crypto",
      downloadReceipt: "Télécharger le reçu"
    },

    payoutDemo: {
      approved: "PAIEMENT APPROUVÉ",
      paid: "PAYÉ",
      amount: "Montant du paiement",
      date: "Date :",
      to: "À :",
      method: "Méthode :",
      account: "Compte :",
      congratulations: "Félicitations pour votre paiement !",
      fundsTransferred: "Vos fonds ont été transférés avec succès sur votre compte."
    }
  },
  platformShowcase: {
    badge: "Une plateforme. Tous les outils. Sans limites.",
    title: "Hub de trading",
    titleHighlight: "tout-en-un",
    titleEnd: "pour les prop traders",
    subtitle: "Tout votre trading. Un seul tableau de bord intelligent. Analysez, gérez et exécutez — plus vite, plus clairement, mieux.",

    platform: {
      dashboard: "Tableau de bord",
      subtitle: "Interface unifiée",
      badge: "NXT Hub 2.0",
      liveData: "Données en direct",
      currentSlideTitle: "Suite de graphiques avancés"
    },

    features: {
      security: "Sécurité bancaire",
      securityDesc: "Chiffrement 256 bits",
      execution: "Exécution ultra-rapide",
      executionDesc: "Sub-milliseconde",
      indicators: "100+ indicateurs",
      indicatorsDesc: "Analyse technique",
      awardWinning: "Primée",
      awardWinningDesc: "Leader du secteur"
    },

    floating: {
      realTimeData: "Données de marché en temps réel",
      advancedAnalytics: "Analyses avancées",
      lightningExecution: "Exécution éclair",
      uptime: "Disponibilité",
      latency: "Latence",
      support: "Support"
    }
  },
  pricingSection: {
    badge: "Choisissez votre capital de trading",
    title: "Commencez à trader avec",
    titleHighlight: "notre capital",
    subtitle: "Choisissez la taille de compte parfaite pour votre style de trading. Tous les plans incluent l'accès complet à la plateforme et un support professionnel.",
    mostPopular: "Le plus populaire",
    tradingCapital: "Capital de trading",
    only: "Seulement",
    month: "mois",
    per30Days: "/{{days}} jours",
    getAccess: "Accédez à {{capital}} de capital",
    getFunded: "SOYEZ FUNDED",
    allPlansInclude: "Tous les plans incluent",
    fullPlatformAccess: "Accès complet à la plateforme",
    completeAccess: "Accès complet à tous les outils de trading",
    level2MarketData: "Données de marché de niveau 2",
    chooseDataFeed: "Choisissez votre flux de données préféré",
    premiumSupport: "Support premium",
    professionalSupport: "Support de trading professionnel 24/7",
    minTradingDays_one: "Min. {{days}} jour de trading",
    minTradingDays_other: "Min. {{days}} jours de trading",
    profitSplit: "{{split}} % de partage des profits",
    maxLots_one: "Max. {{lots}} lot ({{micros}} micros)",
    maxLots_other: "Max. {{lots}} lots ({{micros}} micros)",
    profitTarget: "{{target}} $ d'objectif de profit",
    maxLoss: "{{loss}} $ de perte max.",
    loadingProducts: "Chargement des produits...",
    errorLoading: "Erreur de chargement des produits",
    noProducts: "Aucun produit disponible"
  },
  testimonials: {
    badge: "Paiements vérifiés",
    title: "Des milliers de traders payés.",
    titleHighlight: "Des millions vérifiés.",
    titleEnd: "Confiance gagnée.",
    subtitle: "De vrais traders, de vrais profits, de vrais paiements. Consultez les certificats de nos traders funded dans le monde entier.",
    certificate: {
      title: "Certificat de paiement",
      fundedAccount: "Compte Funded",
      account: "Compte",
      trader: "Trader",
      payout: "Paiement",
      certificateId: "ID du certificat",
      paid: "PAYÉ"
    }
  },
  purchaseModal: {
    title: "Finaliser l'achat",
    subtitle: "Processus de paiement sécurisé",
    resetSubtitle: "Réinitialiser le solde et les statistiques du compte",
    resetDescription: "Réinitialisez les statistiques et le solde de votre compte. Veuillez noter que ce produit ne prolonge pas la durée de votre compte de trading.",
    extensionDescription: "Ce produit prolonge votre compte de trading de 30 jours supplémentaires. Il n'a aucun effet sur vos statistiques de trading.",
    fundedFeeDescription: "Il s'agit des frais d'activation de votre nouveau compte Funded et de tout compte Funded supplémentaire activé pendant cette période.",
    personalInformation: "Informations personnelles",
    personalInfoDescription: "Veuillez fournir vos coordonnées personnelles",
    firstName: "Prénom",
    lastName: "Nom",
    enterFirstName: "Entrez votre prénom",
    enterLastName: "Entrez votre nom",
    emailAddress: "Adresse e-mail",
    enterEmail: "Entrez votre adresse e-mail",
    country: "Pays",
    countryOrRegion: "Pays ou région",
    selectCountry: "Sélectionnez votre pays",
    searchCountries: "Rechercher des pays...",
    noCountriesFound: "Aucun pays trouvé",
    streetAddress: "Adresse",
    address: "Adresse",
    enterStreetAddress: "Entrez votre adresse",
    postalCode: "Code postal",
    enterPostalCode: "Entrez votre code postal",
    city: "Ville",
    enterCity: "Entrez votre ville",
    challenge: "Évaluation",
    profitTarget: "Objectif de profit",
    maxDailyLoss: "Perte quotidienne max",
    maxTotalLoss: "Perte totale max",
    maxLoss: "Perte max",
    profitSplit: "Partage des profits",
    minTradingDays: "Jours de trading min.",
    maxLots: "Contrats max",
    continue: "Continuer",
    continueToPayment: "Continuer vers le paiement",
    personal: "Personnel",
    payment: "Paiement",
    paymentDetails: "Détails de paiement",
    paymentInformation: "Informations de paiement",
    securePayment: "Traitement de paiement sécurisé",
    paymentMethod: "Mode de paiement",
    currency: "Devise",
    card: "Carte",
    cardNumber: "Numéro de carte",
    enterCardNumber: "1234 5678 9012 3456",
    expiration: "Expiration",
    enterExpiry: "MM/AA",
    cvv: "CVV",
    enterCvv: "123",
    fullName: "Nom complet",
    cardholderName: "Nom du titulaire",
    enterCardholderName: "Jean Dupont",
    creditCard: "Carte de crédit",
    expiryDate: "Date d'expiration",
    securePaymentTitle: "Paiement sécurisé",
    securePaymentDescription: "Vos informations de paiement sont chiffrées et sécurisées.",
    paypal: "PayPal",
    paypalEmail: "E-mail PayPal",
    enterPaypalEmail: "votre.email@exemple.com",
    paypalPayment: "Paiement PayPal",
    paypalRedirectDescription: "Vous serez redirigé vers PayPal pour finaliser votre paiement",
    stripeRedirectDescription: "Vous serez redirigé vers Stripe pour finaliser votre paiement en toute sécurité",
    bitpayRedirectDescription: "Vous serez redirigé vers BitPay pour finaliser votre paiement en cryptomonnaie en toute sécurité",
    soon: "Bientôt",
    crypto: "Crypto",
    cryptocurrency: "Cryptomonnaie",
    cryptoPayment: "Paiement en cryptomonnaie",
    selectCryptocurrency: "Sélectionner la cryptomonnaie",
    cryptoInstructions: "Vous recevrez les instructions de paiement pour {cryptoType} après la confirmation de la commande",
    cryptoImportantNote: "Veuillez vous assurer d'envoyer le montant exact à l'adresse fournie",
    termsAndConditions: "J'accepte les conditions générales et la politique de confidentialité",
    reviewConfirm: "Vérifier et confirmer",
    reviewConfirmDescription: "Veuillez vérifier votre commande avant de finaliser",
    orderSummary: "Récapitulatif de commande",
    product: "Produit",
    price: "Prix",
    productDiscount: "Réduction produit",
    discountedPrice: "Prix réduit",
    coupon: "Coupon",
    finalPrice: "Prix final",
    couponCode: "Code coupon",
    enterCouponCode: "Entrez le code coupon",
    applyCoupon: "Appliquer",
    couponHelp: "Entrez un code coupon valide pour obtenir une réduction",
    couponApplied: "Coupon appliqué",
    applied: "Appliqué",
    percentDiscountApplied: "{percent} % de réduction appliquée",
    amountDiscountApplied: "{amount} € de réduction appliquée",
    selectDataFeed: "Sélectionner le flux de données",
    targetAccount: "Compte cible",
    agreeToTerms: "J'accepte les",
    termsOfService: "conditions d'utilisation",
    and: "et",
    privacyPolicy: "politique de confidentialité",
    noRefundPolicy: "Toutes les ventes sont définitives — pas de remboursement",
    previous: "Précédent",
    nextStep: "Étape suivante",
    review: "Vérifier",
    completePurchase: "Finaliser l'achat",
    processing: "Traitement...",
    processingPayment: "Traitement du paiement...",
    purchaseSuccessful: "Achat réussi !",
    purchaseSuccessMessage: "Votre compte a été créé et est prêt à l'emploi.",
    redirecting: "Redirection...",
    paymentRedirectTitle: "Page de paiement ouverte",
    paymentRedirectMessage: "La page de paiement a été ouverte dans un nouvel onglet. Veuillez y finaliser votre paiement.",
    paymentRedirectCloseHint: "Après avoir finalisé le paiement, vous pouvez fermer cette fenêtre.",
    paymentRedirectOpenAgain: "Ouvrir à nouveau le lien de paiement",
    paymentRedirectClose: "Fermer cette fenêtre",
    accountCreated: "Votre compte a été créé et sera disponible dans les 24 heures",
    subscriptionDisclaimer: "En créant votre abonnement, vous autorisez {productName} à débiter votre carte pour ce paiement et les paiements futurs conformément à leurs conditions. Vous pouvez toujours annuler votre abonnement.",
    quantity: "Quantité",
    cart: "Votre panier",
    subtotal: "Sous-total",
    tax: "Taxes",
    total: "Total",
    continueToReview: "Continuer vers la vérification",
    reviewAndConfirm: "Vérifier et confirmer",
    tradingSystem: "Système de trading",
    selectTradingSystem: "Veuillez sélectionner un flux de données",
    couponDiscount: "Réduction coupon",
    invalidCoupon: "Le code coupon entré n'existe pas ou a déjà expiré.",
    loadingQuote: "Chargement des détails de prix...",
    retry: "Réessayer",
    useWalletBalance: "Utiliser le solde du portefeuille",
    walletBalanceAvailable: "Disponible : {symbol}{amount}",
    walletCoversFullAmount: "Le portefeuille couvre le montant total — aucun paiement externe nécessaire",
    walletPartialCover: "Le reste de {symbol}{amount} sera débité via {method}",
    walletApplied: "Crédit portefeuille",
    remainingAmount: "Montant restant",
    volumeDiscount: "Réduction volume",
    volumeDiscountSavings: "Vous économisez {symbol}{amount} par unité",
    volumeDiscountApplied: "Réduction volume appliquée ({percentage} % de réduction)",
    blacklistedTitle: "Achat non disponible",
    blacklistedMessage: "Vous n'êtes actuellement pas autorisé à acheter de nouvelles évaluations. Veuillez contacter notre équipe de support pour plus de détails."
  },
  contactModal: {
    title: "Contactez-nous",
    subtitle: "Nous sommes là pour vous aider à réussir",
    messageSentTitle: "Message envoyé avec succès !",
    messageSentDescription: "Merci de nous avoir contactés. Notre équipe vous répondra dans les 24 heures.",
    exploreWhileWaiting: "En attendant, n'hésitez pas à explorer les fonctionnalités de notre plateforme ou à consulter notre processus d'évaluation.",
    firstName: "Prénom",
    enterFirstName: "Entrez votre prénom",
    lastName: "Nom",
    enterLastName: "Entrez votre nom",
    emailAddress: "Adresse e-mail",
    enterEmail: "Entrez votre e-mail",
    accountNumber: "Numéro de compte",
    accountNumberPlaceholder: "Votre numéro de compte (optionnel)",
    subject: "Sujet",
    selectSubject: "Sélectionnez un sujet",
    generalInquiry: "Demande générale",
    evaluationProcess: "Processus d'évaluation",
    platformSupport: "Support de la plateforme",
    fundingQuestions: "Questions sur le financement",
    technicalSupport: "Support technique",
    partnership: "Partenariat",
    message: "Message",
    messagePlaceholder: "Dites-nous comment nous pouvons vous aider...",
    otherWaysTitle: "Autres moyens de nous contacter",
    businessHours: "Heures d'ouverture",
    businessHoursTime: "Lun-Ven : 8h00 - 20h00 GST",
    sendingMessage: "Envoi du message...",
    sendMessage: "Envoyer le message",
    errorSending: "Échec de l'envoi du message. Veuillez réessayer.",
    overlayTitle: "Contactez-nous par e-mail",
    overlayDescription: "Pour toute question, demande ou si vous avez besoin d'aide, écrivez-nous directement à :",
    overlayButton: "Envoyer un e-mail"
  },
  partnershipModal: {
    title: "Partenariats stratégiques",
    subtitle: "Opportunités de collaboration exclusives",
    tabs: {
      overview: "Vue d'ensemble",
      brandAmbassador: "Ambassadeur de marque",
      exclusiveContracts: "Contrats exclusifs"
    },
    overview: {
      heroTitle: "Devenez notre",
      heroTitleHighlight: "partenaire",
      heroTitleEnd: "et grandissez avec nous",
      heroDescription: "Découvrez nos programmes de partenariat adaptés à vos besoins, que vous soyez un influenceur ou une entreprise établie.",
      brandAmbassador: {
        title: "Ambassadeur de marque",
        subtitle: "Programme créateurs de contenu",
        description: "Parfait pour les influenceurs, éducateurs et créateurs de contenu qui souhaitent présenter notre plateforme à leur audience.",
        benefits: {
          customCodes: "Codes de parrainage personnalisés et suivi",
          exclusiveContent: "Accès à du contenu marketing exclusif",
          prioritySupport: "Support client prioritaire",
          marketingCollaboration: "Opportunités de collaboration marketing directe"
        }
      },
      exclusiveContracts: {
        title: "Contrats exclusifs",
        subtitle: "Partenariats corporatifs",
        description: "Accords sur mesure pour les entreprises établies, sociétés de trading et professionnels du secteur recherchant une collaboration plus approfondie.",
        benefits: {
          customProfitSplits: "Arrangements de partage des profits négociés sur mesure",
          dedicatedManager: "Gestionnaire de compte dédié et équipe de support",
          whiteLabelSolutions: "Options de plateforme et de marque en marque blanche",
          revenueSharingModels: "Modèles avancés de partage des revenus et de partenariat"
        }
      },
      keyBenefits: {
        title: "Avantages clés de nos partenariats",
        higherCommissions: {
          title: "Commissions plus élevées",
          description: "Bénéficiez de taux de commission et de structures de bonus leaders du secteur."
        },
        dedicatedSupport: {
          title: "Support dédié",
          description: "Recevez un support personnalisé de notre équipe de gestion des partenaires."
        },
        globalReach: {
          title: "Portée mondiale",
          description: "Développez votre marque grâce à notre présence internationale."
        }
      }
    },
    brandAmbassador: {
      heroTitle: "Devenez notre",
      heroTitleHighlight: "ambassadeur de marque",
      heroDescription: "En tant qu'ambassadeur de marque, vous représentez Nextproptrader et bénéficiez d'avantages et de commissions exclusifs.",
      requirements: {
        title: "Exigences pour les ambassadeurs de marque",
        audienceSize: {
          title: "Audience engagée",
          description: "Preuve d'une présence en ligne active et engagée."
        },
        contentQuality: {
          title: "Contenu de haute qualité",
          description: "Création de contenu pertinent et engageant pour les traders."
        },
        engagementRate: {
          title: "Taux d'engagement élevé",
          description: "Forte interaction avec votre communauté."
        },
        brandAlignment: {
          title: "Alignement de marque",
          description: "Vos valeurs sont alignées avec celles de Nextproptrader."
        }
      },
      exclusiveBenefits: {
        title: "Avantages exclusifs",
        customReferralCodes: {
          title: "Codes de parrainage personnalisés",
          description: "Codes personnalisés pour votre audience."
        },
        exclusiveContent: {
          title: "Contenu marketing exclusif",
          description: "Accès à des bannières, vidéos et textes spéciaux."
        },
        marketingMaterials: {
          title: "Matériel marketing complet",
          description: "Ressources professionnelles pour soutenir votre promotion."
        },
        directCommunication: {
          title: "Communication directe",
          description: "Ligne directe avec notre équipe de gestion des partenaires."
        }
      }
    },
    exclusiveContracts: {
      heroTitle: "pour des",
      heroTitleHighlight: "contrats exclusifs",
      heroDescription: "Partenariats sur mesure pour les entreprises et les leaders du secteur recherchant une intégration et une collaboration plus approfondies.",
      professionals: {
        title: "Traders professionnels",
        subtitle: "Accords individuels",
        description: "Pour les traders expérimentés qui souhaitent trader avec notre capital et bénéficier de conditions personnalisées.",
        benefits: {
          customProfitSplit: "Partage des profits personnalisé",
          accessToAlgorithms: "Accès aux algorithmes propriétaires",
          tradeWithTeam: "Tradez avec notre équipe",
          profitFromCapital: "Profitez de notre capital"
        }
      },
      industryLeaders: {
        title: "Leaders du secteur",
        subtitle: "Alliances stratégiques",
        description: "Pour les entreprises recherchant une solution en marque blanche ou un partenariat stratégique plus approfondi.",
        benefits: {
          revenueSharing: "Modèles de partage des revenus",
          whiteLabelOptions: "Options en marque blanche",
          coMarketingOpportunities: "Opportunités de co-marketing",
          customBrandingSolutions: "Solutions de marque personnalisées"
        }
      }
    },
    contact: {
      title: "Intéressé par un partenariat ?",
      description: "Contactez-nous pour en savoir plus sur nos programmes de partenariat sur mesure et comment nous pouvons grandir ensemble.",
      button: "Contactez-nous"
    }
  },
  affiliateModal: {
    title: "Programme d'affiliation",
    subtitle: "Gagnez des commissions en parrainant des traders",
    tabs: {
      overview: "Vue d'ensemble",
      benefits: "Avantages",
      requirements: "Exigences"
    },
    overview: {
      heroTitle: "Gagnez",
      heroTitleHighlight: "10 % de commission",
      heroTitleEnd: "sur chaque parrainage",
      heroDescription: "Rejoignez notre programme d'affiliation et gagnez des commissions généreuses pour chaque trader que vous parrainez chez Nextproptrader.",
      features: {
        highCommissions: {
          title: "Commissions élevées",
          subtitle: "Taux leaders du secteur",
          description: "Gagnez 10 % de commission sur chaque parrainage réussi avec la possibilité de taux plus élevés en fonction de la performance."
        },
        customerDiscounts: {
          title: "Réductions pour les clients",
          subtitle: "De la valeur pour votre audience",
          description: "Vos parrainages bénéficient de réductions exclusives, facilitant la conversion et apportant une vraie valeur à votre audience."
        }
      },
      commissionCalculator: {
        title: "Calculateur de commissions",
        sales: "ventes",
        proPlan: "Plan Pro moy.",
        mixedPlans: "Plans mixtes",
        averagePlan: "Plan moyen",
        monthlyGoal: "Objectif mensuel"
      },
      partnershipRewards: {
        title: "Récompenses de partenariat à long terme",
        description: "Construisez une source de revenus durable avec notre programme de partage du succès des traders.",
        features: {
          traderSuccess: {
            title: "Bonus de succès des traders",
            description: "Gagnez des récompenses supplémentaires quand vos parrainages deviennent rentables"
          },
          partnership: {
            title: "Niveaux de partenariat",
            description: "Débloquez des taux de commission plus élevés et des avantages exclusifs"
          },
          passiveIncome: {
            title: "Revenu passif",
            description: "Continuez à gagner grâce aux traders à succès à long terme"
          }
        },
        premiumBenefits: {
          title: "Avantages de partenariat premium",
          description: "Les meilleurs affiliés accèdent à des opportunités de partenariat exclusives, des pages de destination personnalisées et une collaboration directe avec notre équipe marketing."
        }
      }
    },
    benefits: {
      highConversion: {
        title: "Taux de conversion élevés",
        description: "Notre partage des profits transparent à 100 % et notre plateforme professionnelle convertissent exceptionnellement bien."
      },
      premiumBrand: {
        title: "Marque premium",
        description: "Promouvez une société de prop trading respectée et professionnelle avec une excellente réputation."
      },
      bonusPayments: {
        title: "Bonus de performance",
        description: "Gagnez des bonus supplémentaires basés sur le succès à long terme de vos parrainages."
      },
      marketingSupport: {
        title: "Support marketing",
        description: "Accédez à du matériel marketing professionnel, des bannières et du contenu promotionnel."
      },
      realTimeTracking: {
        title: "Suivi en temps réel",
        description: "Suivez vos parrainages, commissions et performances avec des analyses détaillées."
      },
      customerBenefits: {
        title: "Avantages clients",
        description: "Vos parrainages reçoivent des réductions exclusives et des offres spéciales via vos liens."
      },
      payoutInfo: {
        title: "Informations de paiement",
        frequency: {
          value: "Mensuel",
          label: "Fréquence de paiement"
        },
        minimum: {
          value: "50 €",
          label: "Paiement minimum"
        },
        methods: {
          value: "Multiple",
          label: "Modes de paiement"
        }
      }
    },
    requirements: {
      title: "Conditions pour rejoindre",
      nptAccount: {
        subtitle: "Compte requis",
        description: "Vous avez besoin d'un compte Nextproptrader, que vous pouvez créer en commençant une évaluation ou en utilisant le bouton d'inscription ci-dessous."
      },
      marketingCompliance: {
        title: "Conformité marketing",
        description: "Toutes les activités promotionnelles doivent être conformes à nos directives marketing et aux réglementations applicables."
      },
      existingAccountInfo: "Si vous avez déjà un compte Nextproptrader, vous n'avez pas besoin de vous inscrire à nouveau. Vous pouvez utiliser votre compte existant pour le programme d'affiliation — connectez-vous simplement et accédez à la page Affiliation dans le menu.",
      readyToJoin: {
        title: "Prêt à rejoindre notre programme d'affiliation ?",
        description: "Commencez à gagner des commissions dès aujourd'hui en parrainant des traders chez Nextproptrader.",
        loginButton: "Connexion",
        createAccountButton: "Créer un compte"
      },
      register: {
        title: "Créer un compte",
        firstnameLabel: "Prénom",
        firstnamePlaceholder: "Max",
        lastnameLabel: "Nom",
        lastnamePlaceholder: "Mustermann",
        emailLabel: "Adresse e-mail",
        emailPlaceholder: "votre@email.com",
        passwordLabel: "Mot de passe",
        passwordPlaceholder: "Choisissez un mot de passe sécurisé",
        confirmPasswordLabel: "Confirmer le mot de passe",
        confirmPasswordPlaceholder: "Entrez le mot de passe à nouveau",
        passwordMismatch: "Les mots de passe ne correspondent pas.",
        submitButton: "Créer un compte",
        submitting: "Création...",
        successTitle: "Compte vérifié avec succès !",
        successDescription: "Votre e-mail a été vérifié et votre compte est maintenant actif. Vous pouvez vous connecter et accéder à la page Affiliation dans le tableau de bord.",
        genericError: "Une erreur s'est produite. Veuillez réessayer.",
        verifyTitle: "Vérifiez votre e-mail",
        verifyDescription: "Nous avons envoyé un e-mail de vérification à votre adresse. Veuillez entrer le code de l'e-mail ou cliquer sur le lien dans l'e-mail pour vérifier votre compte.",
        codeLabel: "Code de vérification",
        codePlaceholder: "123456",
        codeRequired: "Veuillez entrer le code de vérification.",
        verifyButton: "Vérifier",
        verifying: "Vérification...",
        verifyError: "La vérification a échoué. Veuillez vérifier votre code et réessayer.",
        verifyHint: "Vous n'avez pas reçu d'e-mail ? Vérifiez votre dossier spam ou retournez à l'inscription."
      }
    }
  },
  verifyRegistration: {
    title: "Vérifier l'inscription",
    subtitle: "Vérification du compte",
    verifying: "Vérification de votre compte...",
    success: "Votre compte a été vérifié !",
    successDetail: "Votre e-mail a été confirmé et votre compte est maintenant actif. Vous pouvez vous connecter et commencer à utiliser Nextproptrader.",
    error: "La vérification a échoué. Le lien est peut-être invalide ou expiré.",
    tryCode: "Entrer le code de vérification manuellement",
    codeTitle: "Entrer le code de vérification",
    codeDescription: "Entrez le code de vérification de l'e-mail que nous vous avons envoyé pour compléter votre inscription.",
    emailLabel: "Adresse e-mail",
    emailPlaceholder: "votre@email.com",
    codeLabel: "Code de vérification",
    codePlaceholder: "123456",
    allFieldsRequired: "Veuillez remplir tous les champs.",
    verifyButton: "Vérifier le compte",
    verifyingButton: "Vérification...",
    backToHome: "Retour à la page d'accueil"
  },
  verifyPayment: {
    subtitle: "Vérification du paiement",
    verifying: "Vérification de votre paiement...",
    verifyingDetail: "Nous vérifions le statut de votre paiement. Cela peut prendre quelques instants.",
    success: "Paiement réussi !",
    successDetail: "Votre paiement a été confirmé. Votre compte est en cours de configuration et sera disponible sous peu.",
    failed: "Paiement échoué",
    failedDetail: "Votre paiement n'a pas pu être traité. Veuillez réessayer ou contacter le support si le problème persiste.",
    expired: "Lien de paiement expiré",
    expiredDetail: "Ce lien de paiement a expiré. Veuillez recommencer un nouveau processus de paiement pour finaliser votre achat.",
    timeout: "La vérification prend plus de temps que prévu",
    timeoutDetail: "Votre paiement est peut-être encore en cours de traitement. Vous pouvez réessayer ou vérifier votre e-mail pour une confirmation.",
    retry: "Vérifier à nouveau",
    backToHome: "Retour à la page d'accueil",
    closeTab: "Fermer l'onglet"
  },
  whiteLabelModal: {
    title: "Solution marque blanche",
    subtitle: "Infrastructure et plateforme technologique complètes",
    heroTitle: "Lancez votre propre société de prop trading",
    heroDescription: "Obtenez une plateforme de prop trading entièrement personnalisée et clé en main sous votre propre nom. Notre solution en marque blanche fournit tout ce dont vous avez besoin pour gérer une entreprise de prop trading professionnelle — de l'évaluation des traders à la gestion des comptes funded.",
    features: {
      customBranding: {
        title: "Image de marque personnalisée",
        description: "Personnalisation complète de la marque incluant logo, couleurs, polices et éléments de design pour correspondre à votre identité corporative."
      },
      ownDomain: {
        title: "Votre propre domaine",
        description: "Exécutez votre plateforme sur votre propre domaine avec des certificats SSL personnalisés pour une expérience professionnelle sans couture."
      },
      fullControl: {
        title: "Contrôle total",
        description: "Gérez les traders, comptes, paiements et règles de manière indépendante avec un puissant tableau de bord d'administration."
      },
      cloudHosting: {
        title: "Hébergement cloud",
        description: "Infrastructure cloud de niveau entreprise avec CDN mondial, scaling automatique et garantie de disponibilité de 99,9 %."
      },
      apiAccess: {
        title: "Accès API",
        description: "API REST complète pour une intégration transparente avec vos systèmes existants et services tiers."
      },
      customization: {
        title: "Personnalisation flexible",
        description: "Configurez les règles d'évaluation, les partages de profits, les tailles de compte et les paramètres de trading selon votre modèle commercial."
      }
    },
    whyChoose: {
      title: "Pourquoi la marque blanche ?",
      setup: {
        value: "< 2 semaines",
        label: "Temps de configuration"
      },
      uptime: {
        value: "99,9 %",
        label: "Garantie de disponibilité"
      },
      support: {
        value: "24/7",
        label: "Support technique"
      }
    },
    contact: {
      title: "Prêt à lancer votre solution en marque blanche ?",
      description: "Contactez notre équipe pour discuter de vos besoins en marque blanche et obtenir une solution personnalisée adaptée à votre entreprise.",
      button: "Contacter l'équipe marque blanche"
    }
  },
  affiliateStatus: {
    enroll: {
      title: "Rejoindre le programme d'affiliation",
      subtitle: "Devenez partenaire Nextproptrader",
      description: "Si vous souhaitez participer au programme d'affiliation Nextproptrader, vous pouvez facilement vous inscrire ici. En vous inscrivant, vous confirmez avoir lu et accepter nos conditions d'utilisation, notre politique de confidentialité et nos directives d'affiliation — la participation n'est possible qu'après acceptation.",
      benefits: "En tant qu'affilié, vous aurez accès à un puissant tableau de bord partenaire avec un suivi complet (clics, leads, ventes en temps réel), des liens d'affiliation individuels et la possibilité de créer vos propres codes coupon. Vous bénéficiez de commissions généreuses, de paiements bonus optionnels et d'options de paiement flexibles — y compris le virement bancaire, PayPal ou crypto (selon la disponibilité/option dans le système).",
      button: "S'inscrire maintenant",
      enrolling: "Inscription...",
      trackingTitle: "Suivi en temps réel",
      trackingDesc: "Suivez les clics, leads et ventes en direct",
      linksTitle: "Liens personnalisés",
      linksDesc: "Liens d'affiliation individuels et codes coupon",
      commissionsTitle: "Commissions",
      commissionsDesc: "Rémunération généreuse et paiements bonus",
      payoutsTitle: "Paiements flexibles",
      payoutsDesc: "Virement bancaire, PayPal ou crypto"
    },
    suspended: {
      title: "Compte suspendu",
      description: "Votre compte d'affiliation a été suspendu. Vous n'avez plus accès au programme d'affiliation.",
      support: "Si vous pensez qu'il s'agit d'une erreur ou si vous souhaitez plus d'informations, veuillez contacter notre équipe de support pour des éclaircissements.",
      contactSupport: "Contacter le support"
    },
    pending: {
      title: "Compléter l'inscription d'affiliation",
      subtitle: "Acceptez les conditions et configurez votre profil partenaire",
      step1: "Accepter les conditions",
      step2: "Nom du partenaire",
      loading: "Chargement des accords",
      loadingDescription: "Préparation de votre inscription d'affiliation...",
      termsTitle: "Conditions générales du programme d'affiliation",
      acceptTerms: "J'ai lu et j'accepte les conditions générales du programme d'affiliation",
      continue: "Continuer à l'étape 2",
      nameTitle: "Définissez votre nom de partenaire",
      nameDescription: "Choisissez un nom d'affichage qui sera affiché dans vos matériaux d'affiliation et rapports",
      partnerName: "Nom d'affichage du partenaire",
      partnerNamePlaceholder: "Entrez votre nom de partenaire...",
      back: "Retour",
      complete: "Terminer l'inscription",
      submitting: "Finalisation..."
    },
    complete: {
      title: "Inscription terminée",
      description: "Votre compte d'affiliation est en cours d'activation. Cette page se mettra à jour automatiquement."
    }
  },
  months: {
    january: "Janvier",
    february: "Février",
    march: "Mars",
    april: "Avril",
    may: "Mai",
    june: "Juin",
    july: "Juillet",
    august: "Août",
    september: "Septembre",
    october: "Octobre",
    november: "Novembre",
    december: "Décembre"
  },
  partnerLanding: {
    backToMainSite: "Retour au site principal",
    officialPartner: "Partenaire officiel",
    heroDescription: "Obtenez un accès exclusif au prop trading professionnel avec des avantages partenaires spéciaux. Commencez votre parcours de trading funded avec",
    profitSplit: "100 % de partage des profits",
    noHiddenFees: "et pas de frais cachés.",
    benefits: {
      exclusiveDiscounts: {
        title: "Réductions exclusives",
        description: "Tarifs spéciaux disponibles uniquement via {partner}"
      },
      profitSplit: {
        title: "100 % de partage des profits",
        description: "Gardez tout ce que vous gagnez — pas de prélèvements cachés"
      },
      premiumSupport: {
        title: "Support premium",
        description: "Support prioritaire en tant que parrainage partenaire"
      }
    },
    startEvaluation: "Commencez votre évaluation",
    whyChoose: "Pourquoi choisir",
    whyChooseBadge: "Nos avantages",
    recommendedBy: "Recommandé par {partner} pour les traders sérieux qui veulent de vrais résultats",
    features: {
      profitSplit: {
        title: "100 % de partage des profits",
        description: "Gardez tout ce que vous gagnez. Pas de prélèvements ni de frais cachés."
      },
      dailyPayouts: {
        title: "Paiements quotidiens",
        description: "Accédez à vos profits immédiatement, pas des semaines plus tard."
      },
      transparentRules: {
        title: "Règles transparentes",
        description: "Des règles claires et équitables sans restrictions surprises."
      },
      noTimePressure: {
        title: "Pas de pression temporelle",
        description: "Tradez à votre rythme — pas de jours de trading minimum requis."
      }
    },
    pricing: {
      exclusiveBadge: "TARIFS PARTENAIRES EXCLUSIFS",
      title: "Tarifs spéciaux pour la",
      community: "communauté",
      description: "Obtenez des réductions exclusives et commencez à trader avec notre capital dès aujourd'hui. Offre limitée !"
    },
    testimonial: {
      title: "Approuvé par",
      quote: "{partner} a soigneusement sélectionné Nextproptrader comme société de prop trading préférée pour notre communauté. Avec leur partage des profits à 100 % et leur approche transparente, ils s'alignent parfaitement avec nos valeurs d'aide aux traders pour réussir.",
      stats: {
        profitSplit: "Partage des profits",
        daily: "Quotidien",
        payouts: "Paiements",
        oneDay: "5 jours",
        minEvaluation: "Évaluation min."
      }
    },
    howItWorks: {
      badge: "Comment ça marche",
      title: "Comment ça",
      titleHighlight: "fonctionne",
      subtitle: "Un processus simple en 3 étapes pour être funded et commencer à gagner",
      steps: {
        step1: {
          title: "Choisissez votre plan",
          description: "Sélectionnez la taille de compte adaptée à votre style de trading et bénéficiez de réductions partenaires exclusives."
        },
        step2: {
          title: "Réussissez l'évaluation",
          description: "Atteignez votre objectif de profit tout en gérant correctement le risque — pas de pression temporelle."
        },
        step3: {
          title: "Soyez funded et payé",
          description: "Recevez votre compte funded et commencez à gagner avec 100 % de partage des profits et des paiements quotidiens."
        }
      }
    },
    finalCta: {
      title: "Prêt à trader avec",
      titleHighlight: "notre capital ?",
      description: "Rejoignez des milliers de traders à succès qui font confiance à Nextproptrader. Commencez dès aujourd'hui avec les tarifs exclusifs {partner}.",
      viewPricing: "Voir les tarifs partenaires",
      learnMore: "En savoir plus sur Nextproptrader"
    }
  },
  kyc: {
    title: "Vérification d'identité",
    subtitle: "Vérification KYC",
    introTitle: "Vérifiez votre identité",
    introDescription: "Avant de pouvoir demander un retrait, nous devons vérifier votre identité. Il s'agit d'un processus unique requis par les normes réglementaires pour garantir la sécurité de votre compte et de vos fonds.",
    introStep1: "Indiquer votre date de naissance",
    introStep2: "Confirmer votre nationalité et votre pays de résidence",
    introStep3: "Télécharger une pièce d'identité officielle valide",
    introNote: "Vos données sont cryptées et stockées en toute sécurité. Nous les utilisons uniquement à des fins de vérification conformément aux réglementations applicables.",
    startVerification: "Commencer la vérification",
    stepPersonal: "Infos personnelles",
    stepDocument: "Document",
    stepReview: "Vérification",
    personalInfoTitle: "Informations personnelles",
    personalInfoDesc: "Veuillez fournir vos informations personnelles telles qu'elles apparaissent sur votre pièce d'identité officielle.",
    dateOfBirth: "Date de naissance",
    nationality: "Nationalité",
    residenceCountry: "Pays de résidence",
    searchCountry: "Rechercher un pays...",
    continue: "Continuer",
    documentTitle: "Document d'identité",
    documentDesc: "Téléchargez une photo claire ou un scan de votre pièce d'identité officielle.",
    acceptedDocuments: "Documents acceptés",
    docPassport: "Passeport valide",
    docIdCard: "Carte d'identité nationale",
    docRequirements: "JPG, PNG, WebP ou PDF. Max 10 Mo. Assurez-vous que le document est clairement visible et que tous les détails sont lisibles.",
    dragOrClick: "Cliquez pour télécharger ou glissez-déposez",
    supportedFormats: "JPG, PNG, WebP, PDF - max 10 Mo",
    clickToChange: "Cliquez pour changer le fichier",
    uploadDocument: "Télécharger et continuer",
    back: "Retour",
    reviewTitle: "Vérifiez vos informations",
    reviewDesc: "Veuillez vérifier que toutes les informations sont correctes avant de soumettre.",
    documentUploaded: "Document",
    documentReady: "Document téléchargé",
    reviewWarning: "Veuillez vous assurer que toutes les informations correspondent exactement à vos documents officiels. Des informations incorrectes peuvent retarder le processus de vérification.",
    submitVerification: "Soumettre la vérification",
    successTitle: "Vérification soumise",
    successDescription: "Votre vérification d'identité a été soumise avec succès. Notre équipe examinera vos documents et vous serez notifié une fois le processus terminé.",
    processingTime: "Délai de traitement : jusqu'à 48 heures",
    pendingTitle: "Vérification en cours",
    pendingDescription: "Votre vérification d'identité est actuellement en cours d'examen par notre équipe. Vous serez notifié une fois l'examen terminé. Cela prend généralement jusqu'à 48 heures.",
    close: "Fermer",
    errorStarting: "Impossible de démarrer la vérification. Veuillez réessayer.",
    errorSaving: "Impossible de sauvegarder vos informations. Veuillez réessayer.",
    errorSubmitting: "Impossible de soumettre la vérification. Veuillez réessayer.",
    uploadFailed: "Impossible de télécharger le document. Veuillez réessayer.",
    invalidFileType: "Type de fichier invalide. Veuillez télécharger un fichier JPG, PNG, WebP ou PDF.",
    fileTooLarge: "Le fichier est trop volumineux. La taille maximale est de 10 Mo.",
    rejectedTitle: "Vérification rejetée",
    rejectedDescription: "Malheureusement, votre vérification d'identité a été rejetée. Veuillez consulter la raison ci-dessous et recommencer le processus avec des informations correctes.",
    rejectionReasonLabel: "Raison du rejet",
    rejectedHint: "Vous pouvez recommencer le processus de vérification. Assurez-vous que toutes les informations sont correctes et que vos documents sont clairement lisibles.",
    restartVerification: "Recommencer la vérification"
  },
  countdown: {
    comingSoon: "Bientot Disponible",
    liveNow: "Nous Sommes En Ligne",
    description: "Quelque chose de grand arrive. Preparez-vous pour une nouvelle ere du prop trading.",
    liveDescription: "L'attente est terminee. Bienvenue dans le futur du prop trading.",
    days: "Jours",
    hours: "Heures",
    minutes: "Minutes",
    seconds: "Secondes",
    launchDate: "1er avril 2026 - 08h00 UTC",
    enterCode: "Code d'acces..."
  },
  affiliatePage: {
    nav: {
      home: "Accueil",
      apply: "Postuler gratuitement"
    },
    hero: {
      badge: "PROGRAMME AFFILIÉ NEXTPROPTRADER",
      headline: "Gagnez avec chaque trader que vous recommandez.",
      subline: "Devenez partenaire affilié de Nextproptrader et construisez un revenu évolutif avec un produit solide, des commissions attractives et des niveaux de bonus.",
      cta1: "Postuler gratuitement",
      cta2: "Calculer votre potentiel affilié",
      trust1: "25% Commission affilié",
      trust2: "Meilleures conditions",
      trust3: "100% Payout pour votre communauté",
      trust4: "Bonus uniques",
      dashboardTitle: "Tableau de bord affilié",
      dashboardLive: "En direct",
      dashboardClicks: "Clics",
      dashboardOrders: "Commandes",
      dashboardConversion: "Conversion",
      dashboardCommission: "Commission totale",
      dashboardTier: "Niveau actuel",
      dashboardRecentSales: "Ventes récentes"
    },
    stats: {
      funded: "Capital financé",
      traders: "Traders actifs",
      commission: "Commission affilié",
      bonus: "Bonus unique possible"
    },
    why: {
      headline: "Pourquoi promouvoir Nextproptrader?",
      cards: [
        {
          title: "Un produit qui convainc les traders",
          text: "Nextproptrader offre 100 % de partage des profits, des paiements quotidiens et des évaluations équitables — une offre qui se démarque dans le secteur."
        },
        {
          title: "Structure de commissions compétitive",
          text: "Commencez à 10 % et montez jusqu'à 25 % de commission par vente. Chaque recommandation rapporte directement — sans plafond."
        },
        {
          title: "Bonus uniques aux jalons",
          text: "Atteindre des jalons clés débloque des bonus en espèces uniques — jusqu'à 10 000 € par niveau."
        },
        {
          title: "Tableau de bord en temps réel",
          text: "Suivez clics, conversions et commissions en temps réel. Visibilité complète sur vos performances — partout, à tout moment."
        }
      ]
    },
    tiers: {
      headline: "Votre chemin. Votre commission.",
      subline: "Démarrez en tant qu'affilié et progressez étape par étape vers des niveaux de commission supérieurs.",
      commissionLabel: "Commission",
      bonusLabel: "Bonus unique",
      salesLabel: "à partir de ventes",
      overviewLabel: "Aperçu des niveaux",
      startLevel: "Niveau de départ",
      fromSales: "à partir de {n} ventes",
      tierOf: "Niveau {current} / {total}",
      noMinimum: "Aucun minimum",
      noMinRevenue: "Aucun chiffre d'affaires minimum",
      confirmedSales: "À partir de {n} ventes confirmées",
      maxCommission: "Commission max.",
      descriptions: {
        starter: "Idéal pour débuter. Commencez sans exigences minimales et gagnez immédiatement avec vos premières recommandations. Aucune candidature, aucun chiffre minimum.",
        bronze: "Votre premier jalon. Avec 50 ventes réussies, vous débloquez un bonus unique et prouvez que votre audience convertit.",
        silber: "Performance solide. À 150 ventes, votre bonus atteint 2 500 € — signal clair que votre canal génère de la valeur.",
        gold: "Commission plus élevée. À partir de 300 ventes, votre commission passe à 15% — plus de revenus sur les mêmes recommandations, automatiquement.",
        platin: "Forte portée. 500 ventes prouvent un modèle de recommandation fiable — récompensé par un bonus unique de 5 000 €.",
        diamant: "Top performance. Vous avez construit une machine d'affiliation évolutive. Votre bonus unique : 10 000 €.",
        elite: "Statut élite. Seuls les affiliés les plus performants atteignent ce niveau — avec 25% de commission sur chaque vente et un potentiel illimité."
      }
    },
    calc: {
      headline: "Calculez votre potentiel affilié",
      subline: "Obtenez une estimation approximative de la commission que votre portée pourrait générer.",
      disclaimer: "Ce calcul est une estimation uniquement, basée sur des hypothèses concernant le taux de conversion et la valeur moyenne des commandes.",
      followerLabel: "Vos abonnés / followers",
      conversionLabel: "Taux de conversion estimé",
      salesOutput: "Ventes estimées",
      revenueOutput: "Chiffre d'affaires estimé",
      commissionOutput: "Commission estimée",
      tierOutput: "Niveau actuel",
      progressLabel: "Ventes jusqu'au prochain niveau",
      bonusNote: "Atteindre ce niveau inclut également un bonus unique de",
      bonusNote2: "",
      cta: "Postuler gratuitement",
      basisLabel: "Base de calcul",
      estimatedBuyers: "Acheteurs estimés",
      avgOrderValue: "Valeur moy. commande",
      commissionShort: "Commission",
      perMonthEstimate: "par mois (estimation)",
      footerNote: "Estimation basée sur des moyennes historiques. Les résultats individuels peuvent varier.",
      eliteReached: "Statut élite atteint",
      eliteMax: "Commission maximale de 25%"
    },
    steps: {
      headline: "Comment ça marche",
      items: [
        {
          title: "S'inscrire gratuitement",
          text: "Postulez au programme d'affiliation et obtenez un accès immédiat à votre lien de suivi personnel après validation."
        },
        {
          title: "Partager votre lien affilié",
          text: "Intégrez votre lien dans des vidéos, newsletters, posts sur les réseaux sociaux ou votre site web — touchez votre audience où elle est active."
        },
        {
          title: "Percevoir des commissions",
          text: "Pour chaque achat via votre lien, vous recevez votre commission. En progressant, vous accédez automatiquement à des niveaux supérieurs."
        }
      ]
    },
    faq: {
      headline: "Questions fréquentes",
      items: [
        {
          q: "Quelle est la commission?",
          a: "La commission commence à 10 % (niveau Starter) et peut atteindre 25 % (niveau Elite) selon vos performances. Certains niveaux incluent également des bonus uniques allant jusqu'à 10 000 €."
        },
        {
          q: "Quand suis-je payé?",
          a: "Les modalités de paiement exactes sont communiquées lors de l'intégration. Nous mettons en place un processus de paiement transparent et fiable pour tous les partenaires."
        },
        {
          q: "Y a-t-il des prérequis?",
          a: "Il n'y a pas de nombre minimum d'abonnés ou de seuil de chiffre d'affaires pour postuler. Toute personne touchant une audience pertinente dans le trading ou la finance peut postuler."
        },
        {
          q: "Quelle est la durée du cookie?",
          a: "La durée du cookie de suivi est communiquée dans le tableau de bord affilié. Une fenêtre de cookie plus longue permet généralement de meilleurs taux de conversion."
        },
        {
          q: "Puis-je créer plusieurs liens?",
          a: "Oui. Dans le tableau de bord affilié, vous pouvez créer plusieurs liens de suivi pour différents canaux, campagnes ou contenus, et suivre leurs performances séparément."
        }
      ]
    },
    cta: {
      headline: "Prêt à grandir en tant qu'affilié Nextproptrader?",
      subline: "Postulez gratuitement et accédez au programme d'affiliation.",
      button: "Postuler gratuitement",
      support: "Gratuit. Sans engagement. Démarrage rapide."
    },
    footer: {
      copy: "© 2024 Nextproptrader. Tous droits réservés.",
      program: "Programme Affilié"
    }
  }
};